/* eslint-disable no-unused-vars */

const crystalsData = [
  {
    title: 'Abalone Shell',
    img: '',
    description:
      'While Abalone is a type of mollusk, the shell is an iridescent beauty used in jewelry and spiritual healing. Its healing energy is said to be highly protective and it removes negative energy from your environment with ease. It’s often used with smudge sticks for cleansing. Due to its ethereal aesthetic, Abalone Shell has garnered quite a reputation for being a calming stone that can easily bring you into a trance.',
    chakra: 'Crown, Third Eye, Heart',
    zodiac: 'Cancer, Aquarius, Pisces',
    bestfor: 'Protection, Inner Peace, Cleansing, Love',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/abalone',
  },
  {
    title: 'Actinolite',
    description:
      "Needle-like in its appearance, Actinolite is a great stone for starting fresh and approaching old problems from a new perspective. These gemstones are excellent for incorporating into your emotional healing practices. They have the ability to prevent negative energies from leeching away at your aura. It's a healing crystal for self-care, encouraging you to look after yourself and your energy.",
    chakra: 'Heart',
    zodiac: 'Scorpio',
    bestfor: 'New Beginnings, Self-Healing, Emotional Understanding',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Adamite',
    description:
      "Adamite fuses the solar plexus chakra with the heart chakra. It gives the desires of your heart the attention they need to be fulfilled. A stone of courage, inner strength, and willpower, Adamite is a striking stone that can be used to enhance your other pieces. Usually found in small pieces, Adamite is more of a complimentary gem than a full force to wield on its own. It's perfect for those suffering from depression, loneliness, or anxiety.",
    chakra: 'Heart, Solar Plexus',
    zodiac: 'Cancer',
    bestfor: 'Courage, Inspiration, Willpower',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Aegirine',
    description:
      "The high vibrational energy of Aegirine makes it one of the top crystals for healing you energetically. It's a brilliant cleanser, dismantling negative vibes in your surrounding environment and making you feel fresh and revitalized. Aegirine unlocks your inner strength and helps you display the confidence needed to attract positive energy your way. Supercharging and aligning all seven chakras, Aegirine brings balance to your mental, spiritual and emotional bodies.",
    chakra: 'All',
    zodiac: 'Taurus, Pisces',
    bestfor: 'Balance, Confidence, Self-Discipline',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Agate',
    description:
      "Agate is the name of a family of powerful healing crystals, each one bringing something unique to the table. From Moss Agate to Fire Agate to Blue Lace Agate, the Agate crystal meanings vary from passion and creativity to relaxing stillness. The crystal power of Agate manifests itself in different ways and different chakras depending on the type of Agate. There is one thing that all Agate stones have in common, however. They're all masters at lifting your spirits.",
    indiantext:
      "Another gemstone that's sure to never go out of style is Agate from India. This eye-catching stone comes in various colors, ranging from black and brown to pink and blue. Its richness lies in its bands, which can easily draw your eye like a magnet. Look for it mainly in Gujarat, Madhya Pradesh, and Uttar Pradesh.",
    australiantext:
      'Australian Agate is distinguished by its bright colors, often with a banded pattern. You can find this gemstone in several areas, with North Queensland, Tasmania, and Wave Hill being the most common spots.',
    srilankatext:
      "Sri Lankan Agate is known for its layered, striped patterns that offer a dazzling array of colors. Find your treasure in the country's Uva, North Central, and Sabaragamuwa Provinces. If you've been searching for a unique and truly one-of-a-kind gem, then you'll want to take a trip to the country's Ratnapura District.",
    chakra: 'All',
    zodiac: 'Gemini',
    bestfor: 'Clarity, Calming Energy, Uplifting Energy',
    jevelry: 'https://consciousitems.com/collections/agate',
    bracelets: 'https://consciousitems.com/collections/agate-bracelet',
    rings: 'https://consciousitems.com/collections/agate-ring',
    link: 'https://consciousitems.com/blogs/lifestyle/agate-stone-meaning',
    indian: 'indian',
    australian: 'australian',
    srilanka: 'srilanka',
  },
  {
    title: 'Agnitite',
    description:
      "Named after the Vedic deity of fire, Agni, Agnitite helps you harness your fire energy and direct it towards your passions. It's an excellent gemstone for creative energies and helps you bring your thoughts and ideas to life. It stimulates the entire liquid crystal body matrix, infusing it with the divine prana energy. Use Agnitite to connect with your inner goddess on a deeper level.",
    chakra: 'All',
    zodiac: 'Leo',
    bestfor: 'Passion, Creativity, Intuition',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/a-guide-to-agnitite',
  },
  {
    title: 'Agrellite',
    description:
      "Agrellite is a powerful heart chakra balancer. It reconnects you to your true self and helps you find your life path if you've veered off course. If you find yourself blaming others, or having sudden bursts of anger or jealousy, then Agrellite will soothe your spirit and help you find inner peace. It's a fantastic stone for becoming deeply aware of your self-worth and how it correlates to your happiness.",
    chakra: 'Heart',
    zodiac: 'Aquarius',
    bestfor: 'Love, Compassion, Self-Worth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Ajoite',
    description:
      "A brilliant gem for getting in touch with your true essence, Ajoite is a gorgeous crystal, brimming with feminine energy. It helps you reclaim your divine spirit. Ajoite also facilitates greater self-awareness, helping you value yourself more and increase your self-image. It's a fantastic gemstone to use for overcoming mental trauma of any kind. Sending waves of positive energy through the upper chakras, Ajoite fuels your self-expression and encourages you to show your authentic self to the world.",
    chakra: 'Heart, Throat, Crown',
    zodiac: 'Virgo',
    bestfor: 'Feminine Energy, Connection With Spirit, Self-Awareness',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Alabaster',
    description:
      "Alabaster is a translucent form of gypsum, named after an Egyptian town. Commonly referred to as the 'Drawing Stone', Alabaster is said to magnetically pull things you need towards you. For this reason, Alabaster is a great stone to use in intention-setting or manifestation practices. Treat it like your personal prosperity magnet. It works great at soothing tension and relaxing your muscles after a long day.",
    chakra: 'Root, Sacral',
    zodiac: 'Aries',
    bestfor: 'Manifestation, Intentions, Prosperity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Alexandrite',
    description:
      "Alexandrite is a tough crystal that invokes a spiritual transformation in the owner. When working with this gemstone, it's hard not to feel the spiritual tug. It helps you take a step back from the hustle and bustle of daily life, making it one of the top gemstones for meditative practices of any kind. Alexandrite encourages you to reconnect with the etheric realms, which empowers you to become the master of your fears. It allows you to become conscious of the subconscious.",
    text: 'Sri Lankan Alexandrite has a vivid green color in daylight and changes to a sumptuous raspberry red under incandescent light. A must-have for any collector! Seek them out in the Sabaragamuwa or Western Province.',
    chakra: 'Heart, Throat, Third Eye, Soul Star',
    zodiac: 'Scorpio',
    bestfor: 'Overcoming Fear, Motivation, Inner Peace',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/practice/alexandrite-stone',
    srilanka: 'srilanka',
  },
  {
    title: 'Almandine',
    description:
      'Almandine, otherwise known as Almandine Garnet, is a powerful earthy stone that anchors your energy to the present moment. When it comes in the form of raw crystals, Almandine has even stronger grounding properties. The tumbled stones are great to keep hold of too, unlocking your latent potential for passion, creativity, and sexual energies. A stunning regenerative crystal, Almandine stimulates your base chakra and activates your kundalini energy. One of its most powerful abilities is to alleviate fear, helping you to manifest your tangible truth.',
    text: 'Almandine Garnet can be found primarily in the Central Province and the Sabaragamuwa Province, usually with a deep red or purplish hue—bordering on black. Sri Lankan Almandine is found in the Central, Southern, and Sabaragamuwa Provinces.',
    chakra: 'Root',
    zodiac: 'Aquarius',
    bestfor: 'Grounding Energy, Truth, Manifestation, Fertility',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    srilanka: 'srilanka',
  },
  {
    title: 'Amazonite',
    description:
      "Known as the 'Stone of Hope', Amazonite brings peace and love to all decisions. It enables you to be free and playful, knowing that you are protected at the highest possible level. Why worry about the little things? Amazonite helps you maintain optimism so that you can show gratitude rather than anxiety. It motivates you to consciously choose positive and joy-bringing thoughts rather than negative ones. Its rejuvenating energy helps you find peace within. It stimulates both the heart and throat chakras, helping you articulate yourself clearly and with love.",
    text: 'Amazonite from Mexico has a pastel blue-green color that conveys peace and tranquility. Some specimens will have a cross-hatched pattern that makes them more irresistible to the eye. We highly recommend visiting Sierra de Peñoles for the best Amazonite',
    chakra: 'Heart, Throat',
    zodiac: 'Virgo',
    bestfor: 'Hope, Communication, Trust, Emotional Healing',
    jevelry: 'https://consciousitems.com/collections/amazonite',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/amazonite-stone-healing-properties',
    blue: 'blue',
    green: 'green',
    mexican: 'mexican',
  },
  {
    title: 'Amber',
    description:
      "Fossilized tree resin has never looked so beautiful! Amber is a bright yellow bundle of joy. Activating the solar plexus chakra, Amber motivates you to succeed, encouraging you to follow your dreams and keep an optimistic mindset for all of your goals. It's a gorgeous stone that has stood the test of time; in doing so, it has an aura that fertilizes your patience, helping you relax and let things be, rather than stress yourself out by chasing them down.",
    mexicantext:
      "Often mistaken for a crystal, Amber is actually fossilized tree resin that has been trapped in time millions of years ago. Mexican Amber is famous for its wide range of colors and hues. Chiapas should be any Amber fan's first destination.",
    australiantext:
      "Amber isn't a gemstone—it's actually fossilized tree resin. Australian Amber is renowned for its bright orange and yellow tones that evokes visions of the outback. The best specimens are mined in Anglesea, Victoria.",
    chakra: 'Solar Plexus, Sacral',
    zodiac: 'Leo, Libra, Aquarius',
    bestfor: 'Abundance, Manifestation, Joy, Wisdom',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/amber',
    orange: 'orange',
    yellow: 'yellow',
    mexican: 'mexican',
    australian: 'australian',
  },
  {
    title: 'Amblygonite',
    description:
      "Ambylgonite's name comes from the Greek words for \"blunt angle\", referring to the crystal's physical appearance. While it might not be the most beautiful stone on this list, it has amazing physical healing properties, especially when it comes to headaches and migraines. Amblygonite can also help with bone disorders and any issues regarding the digestive system. It's an excellent addition to an artist's toolkit, bringing the energy of creativity when you need it most. It can assist those who find it hard to complete what they started. It makes you conscious of your spiritual nature and urges you to express it creatively.",
    chakra: 'All',
    zodiac: 'Taurus',
    bestfor: 'Creativity, Physical Healing, Spiritual Energy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Amethyst',
    description:
      "A wonderful gemstone for sleep, dreams, and all things spiritual, Amethyst is one of the most popular healing crystals in the world. As a member of the Quartz family, Amethyst is a natural healer. It is particularly known for its tranquil vibes, facilitating a deep and unparalleled relaxation. Wear Amethyst jewelry if you struggle with anxiety or insomnia. It's also one of the greatest crystals for connecting with the spiritual realm. Activating the higher chakras, including the etheric chakra that sits above your physical body, Amethyst acts as a doorway between the physical realms and the spiritual realms. It can be used to open up a dialogue with spirit guides as well as to enhance lucid dreaming or astral projection.",
    mexicantext:
      'This gemstone has been known to bring clarity of thought, and in Mexico, it comes in shades of purple ranging from light lavenders to deep violets. Las Vigas is our go-to destination for the very best Amethyst!',
    australiantext:
      "One of the most highly sought-after gemstones, Australian Amethyst is known for its brilliant purple hue, like a royal sunset. You'll find excellent specimens from New South Wales and Broken Hill.",
    srilankatext:
      'Sri Lankan Amethyst is known for its superior quality and intense color. Although the majority of the gems in Sri Lanka are purple, there are also small pockets of yellowish-green, pink, and even blue specimens. Search for the perfect Amethyst in Sabaragamuwa Province or the Western Province!',
    chakra: 'Third Eye, Crown, Etheric',
    zodiac: 'Virgo, Sagittarius, Capricorn, Aquarius, Pisces',
    bestfor: 'Sleep, Tranquility, Clairvoyance',
    jevelry: 'https://consciousitems.com/collections/amethyst',
    bracelets: 'https://consciousitems.com/collections/amethyst-bracelet',
    rings: 'https://consciousitems.com/collections/amethyst-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/amethyst-meaning-ultimate-guide',
    purple: 'purple',
    mexican: 'mexican',
    australian: 'australian',
    srilanka: 'srilanka',
  },
  {
    title: 'Ametrine',
    description:
      'A dazzlingly unique blend of Amethyst and Citrine, Ametrine can only be found in one single mine in Bolivia. If you can get yourself an authentic piece of Ametrine, you can count yourself lucky. Ametrine brings the highest vibrational energy imaginable. With such an elevated frequency, manifestation becomes a breeze. Intentions become more like predetermination. Fears, worries, and stress fall by the wayside, and many report feeling as though an enormous weight has been lifted.',
    text: 'The soft, whimsical blend of colors in Ametrine entices many collectors and jewelry designers. You can find Brazilian Ametrine in Mato Grosso do Sul and Minas Gerais.',
    chakra: 'Solar Plexus, Third Eye, Crown, Soul Star',
    zodiac: 'Gemini, Libra, Pisces',
    bestfor: 'Manifestation, Inner Peace, Transcendence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/ametrine',
    brazilian: 'brazilian',
  },
  {
    title: 'Ammolite',
    description:
      "Ammolite is an Opal-like organic gemstone from the shell of an extinct mollusk. Sometimes referred to as Ammonite, these organic stones hold ancient wisdom that can invoke a spiritual awakening if you integrate it into your spiritual practices. These beautiful stones help us learn from the mistakes of our ancestors and remind us that all is nature, and nature is all. The stresses of daily life aren't going to matter in the long run – only the innate spiritual nature of us all. Ammolite helps you maintain a connection with this aspect of life.",
    chakra: 'Third Eye',
    zodiac: 'Aquarius',
    bestfor: 'Ancient Wisdom, Spiritual Awakening, Truth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Andalusite',
    description:
      "Named after the Spanish locality where it was originally found, Andalusia, this crystal is a polymorph of Kyanite and Sillimanite. Fantastic for easing nutritional deficiencies in the physical body, Andalusite is a great supplement to your typical recovery routines for almost any illness or ailment. It regulates the nervous system and balances the energetic field. It's a great stone for you to hold your tongue if you find yourself ready to snap at somebody that's standing in the way of you and your goals. It protects your emotional body from bad vibes.",
    braziliantext:
      'Prominent deposits of Brazilian Andalusite are found chiefly in Minas Gerais. The color spectrum of Andalusite ranges from pink to a rust-colored brown, though some specimens can be white, yellow, green, or grey.',
    srilankatext:
      "Sri Lankan Andalusite is a fascinating gemstone that typically comes in pink to reddish-brown hues. It's mined in the Western and Sabaragamuwa Provinces—so if you're looking for something truly special then this is one to keep your eye on!",
    chakra: 'Sacral, Heart',
    zodiac: 'Virgo',
    bestfor: 'Physical Healing, Emotional Stability, Protection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    brown: 'brown',
    brazilian: 'brazilian',
    srilanka: 'srilanka',
  },
  {
    title: 'Andradite',
    description:
      'Andradite Garnet is an earthy stone that grounds your energy and connects it to mother nature. All andradite stones hold energy that promotes perseverance and encourages you not to quit on your dreams. You never know what might happen if you keep going. Opening up the mind to a higher standard of thinking, Andradite helps you build better relationships and forge stronger bonds.',
    chakra: 'Root, Solar Plexus, Heart',
    zodiac: 'Aquarius',
    bestfor: 'Protection, Strength, Communication',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Angel Aura Quartz',
    description:
      "Angel Aura Quartz has such a strong vibration that it can be felt at first touch. This man-made marvel is a magical crystal that raises your spirits, boosts your energy, and ignites feelings of love, joy and happiness. When you have a bad day, Angel Aura Quartz will ensure you don't carry the bad energy with you. It stays in the past and doesn't impact your character. It makes you acutely aware that small changes in thought can lead to new behaviors that lead to new habits and eventually new personality traits. It helps you remain conscious of this effect when forming bad habits, and encourages you to use it to formulate good habits instead.",
    chakra: 'Crown, Etheric',
    zodiac: 'Aries',
    bestfor: 'High Vibrational Energy, Self-Awareness, Joy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/angel-aura-quartz-meanings-properties-benefits',
  },
  {
    title: 'Angelite',
    description:
      "A spiritual powerhouse, Angelite is a fantastic gemstone for all things metaphysical. It's one of the greatest gemstones you can use if you want to enhance your lucid dreaming practice. If you're experienced in this field, Angelite will help you lucid dream more often. For beginners, Angelite can help to initiate your first lucid dream. It's also a great support stone for those practicing astral projection. A high-frequency stone, Angelite unveils psychic powers you may not even have been aware of. It uncovers new senses, abilities and perceptions that the mystics have spoken of for generations.",
    chakra: 'Throat, Third Eye, Crown',
    zodiac: 'Aquarius',
    bestfor: 'Lucid Dreaming, Psychic Abilities, Clairvoyance, Astral Projection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/angelite',
    blue: 'blue',
  },
  {
    title: 'Anhydrite',
    description:
      "Somewhere between Gypsum and Angelite, Anhydrite is a powerful gem that brings a soothing wave of acceptance for all that is and all that ever will be. It's a great stone for stoics. Focus on what you can change and let the rest be. It's supportive for those coming to terms with things they dislike, whether it be about themselves, the world, or their relationships. Anhydrite will help you realize that it's your perception of the thing that causes it to continue. Accept it for what it is and remove your preconceptions and your energy is no longer wasted.",
    chakra: 'Throat, Crown',
    zodiac: 'Cancer, Scorpio, Aquarius, Pisces',
    bestfor: 'Inner Peace, Acceptance, Emotional Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Antigorite',
    description:
      "Antigorite is a typically dark green stone first discovered in Valle Antigorio, Italy. It's a type of Serpentine that is said to aid longevity, detoxifying the blood and body. Sometimes found in gray, yellow, brown or black, Antigorite generally works on the lower chakras, helping to stabilize your energy and anchor you in the present moment. It can also stimulate the rise of kundalini energy through your energetic centers.",
    chakra: 'Root, Solar Plexus',
    zodiac: 'Gemini',
    bestfor: 'Emotional Balance, Longevity, Grounding',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Apache Tears',
    description:
      "A wonderful nurturing stone, Apache Tears are a unique variety of Black Obsidian that forms in small pebbles. The name comes from the American invasion of the Apache natives – when the Apaches became severely outnumbered, they decided to take matters into their own hands and rode their horses off the cliff. When their family members and friends heard the tragic news, they cried many tears. It's said that these tears turned to stone: Apache Tears. While the backstory is certainly a sad one, Apache Tears are powerful stress-relievers. They promote emotional stability and help support you through tough times.",
    chakra: 'Root',
    zodiac: 'Scorpio, Sagittarius',
    bestfor: 'Nurturing, Anxiety-Relief, Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/apache-tears',
    black: 'black',
  },
  {
    title: 'Apatite',
    description:
      "Apatite is the name given to a family of stones that raise your energy and boost your connection with the spiritual realm. Most commonly found in a blue color, Apatite can also come in green and yellow. Each one is slightly different, but they each have an abundance of positive energy. They're great stones to work with if you've been feeling low recently. Apatite is a sure-fire way to get you back into a high-vibe spirit.",
    text: 'Apatite specimens often have an interesting combination of colors that can range from light pastel blues and greens to deep teal and blue-green. Sri Lankan Apatite is found all over the country, with the Central Province and Uva Province being some of the most popular hotspots.',
    chakra: 'Solar Plexus, Heart, Throat, Third Eye',
    zodiac: 'Gemini, Capricorn, Pisces',
    bestfor: 'Positive Energy, Vertical Vision, Meditation',
    jevelry: 'https://consciousitems.com/collections/apatite',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/lifestyle/apatite-stone',
    blue: 'blue',
    srilanka: 'srilanka',
  },
  {
    title: 'Apophyllite',
    description:
      "Apophyllite is not the most popular stone, but its spiritual properties are profound. Many who delve into the crystal meanings of Apophyllite claim that it brings them closer to their spirit guides, facilitating communication with them. If you're looking to expand your consciousness and alter your perspective on life and the spirit realm, Apophyllite is the crystal you need. Highly intuitive, this gemstone starts to work its magic the second it gets into your hands. If you enjoy a good meditation session, integrate this gemstone to truly feel the additional benefits.",
    chakra: 'Third Eye, Crown',
    zodiac: 'Gemini, Libra',
    bestfor: 'Meditation, Intuition, Communication with Spirit Guides',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Aquamarine',
    description:
      "A brilliant stone for soothing worries and anxious thoughts, Aquamarine is a support stone that keeps your energy centered. It has been worn by sailors for centuries to protect them out at sea, and can be used to keep seasickness or travel sickness of any kind at bay. If you want to de-stress and connect with your inner peace, Aquamarine is a fantastic choice. Its soothing vibes are like a refreshing splash of water on a hot summer's day. Stimulating the throat chakra, Aquamarine is a brilliant gem if you need a helping hand when it comes to articulating your thoughts, emotions, and ideas too. Aquamarine helps you speak with clarity and precision.",
    indiantext:
      "If you've been looking for something to help you find your inner peace, look no further. Aquamarine from India exudes serenity: its soft pastel hue and gentle energy will bring you a feeling of relaxation and tranquility. Tamil Nadu and Rajasthan are two of the best places to look for Aquamarine in India.",
    australiantext:
      'Aquamarine is a stunning blue-green gemstone that is said to bring courage and luck. If Australian Aquamarine floats your boat, you need to head to the northwest of Townsville for the best specimens.',
    srilankatext:
      "The larger the Aquamarine, the deeper the blue. Sri Lanka's Aquamarine is known to possess a particularly intense blue hue that resembles the color of a tropical ocean. The Sabaragamuwa Province is where miners seek these special gems.",
    braziliantext:
      'Brazilian Aquamarine distinguishes itself by its intense coloration. Evoking the deep blue-green of the ocean, these gems make for some of the most coveted pieces in the jewelry market. Several regions in Brazil produce Aquamarine, including Paraiba, Espirito Santo, Bahia, and others.',
    chakra: 'Heart, Throat',
    zodiac: 'Aries, Gemini, Pisces',
    bestfor: 'Calming Energy, Stress-Relief, Communication, Seasickness',
    jevelry: 'https://consciousitems.com/collections/aquamarine',
    bracelets: 'https://consciousitems.com/collections/aquamarine-bracelet',
    rings: 'https://consciousitems.com/collections/aquamarine-ring',
    link: 'https://consciousitems.com/blogs/lifestyle/aquamarine-stone',
    blue: 'blue',
    indian: 'indian',
    australian: 'australian',
    srilanka: 'srilanka',
    brazilian: 'brazilian',
  },
  {
    title: 'Aragonite',
    description:
      "Most often found displaying a golden brown hue, Aragonite can also come in red, yellow, green, blue, violet, and white. There are several marine animals that are actually made of Aragonite, including Ammonite which can become iridescent over time. As Aragonite balances and activates all seven of the major chakras, it's an important gemstone to get your hands on. The inner balance provided by this gemstone is second to none. If you find yourself feeling a little imbalanced, then Aragonite is a must-have.",
    chakra: 'All',
    zodiac: 'Capricorn',
    bestfor: 'Courage, Motivation, Self-Awareness, Spiritual Healing, Inner Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/your-guide-to-aragonite-and-its-healing-properties',
  },
  {
    title: 'Atlantisite',
    description:
      'An epic combination of Serpentine and Stichtite, Atlantisite ranges from a pale green to a dark green, with purple marks throughout. Sometimes called Tasmanite, Atlantisite is one of the rarest forms of Serpentine. As such, it holds some particularly powerful properties. Like most Serpentine stones, it activates your kundalini energy, stimulating passion and inner balance. It fires up the sexual organs, enhancing fertility and boosting creativity. A highly compassionate stone, Atlantisite helps you forgive and move on from difficult situations, learning and integrating the lessons from each one.',
    chakra: 'All',
    zodiac: 'Virgo, Libra',
    bestfor: 'Compassion, Ancient Wisdom, Kundalini Energy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Aura Quartz Crystals',
    description:
      'Aura Quartz is a type of heat-treated Quartz that can come in a variety of different colors. As these are designed to have more vivid colors and shine brighter, they often have higher vibrations too. Aura Quartz crystals are great for protection, shielding your energy from low vibes. The redder varieties speak of love, passion, and self-confidence, while the brighter yellow types bring optimism, joy, and motivation.',
    chakra: 'All',
    zodiac: 'None',
    bestfor: 'High Frequency, Protection, Positive Energy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Carnelian',
    img: '',
    description:
      'An orange stone often used for bursts of creativity, Carnelian is a passionate powerhouse. One of the top healing crystals for stimulating the sexual energies, Carnelian knows how to work positive energy into your aura. It’s a great stone for self-esteem too as it pushes you to be bold and courageous. With Carnelian nearby, you will feel as though you’re capable of achieving anything.',
    text: "Indian Carnelian is distinguished by its bright orange color, giving it a vitality and energy that's hard to find anywhere else. Gujarat is the place to go if you're looking for this particular gemstone.",
    chakra: 'Sacral',
    zodiac: 'Virgo',
    bestfor: 'Creativity, Sexual Energies, Passion, Courage',
    jevelry: 'https://consciousitems.com/collections/carnelian',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/carnelian-crystal-meaning',
    orange: 'orange',
    indian: 'indian',
  },
  {
    title: 'Desert Rose',
    img: '',
    description:
      'A great stone to supplement meditation, Desert Rose is a brilliant gemstone for mental clarity. As a form of Selenite gypsum, Desert Rose excels at cleansing and purifying. It can even be used to remove negative energies from your other crystals. The Desert Rose crystals and their meanings are universally revered. This is because each Desert Rose crystal is said to contain a spirit guardian. They make for great décor when wanting to add an element of protection to your home.',
    chakra: 'Sacral, Root, Crown',
    zodiac: 'All',
    bestfor: 'Cleansing, Love, Intuition, Protection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/desert-rose-stone',
  },
  {
    title: 'Emerald',
    img: '',
    description:
      'Emerald is a highly sought after gemstone because of its verdant beauty and its fashionable style. However, not many people know that Emerald is also one of the most powerful healing stones for the heart chakra. Not only does it promote positive thinking, Emerald also inspires compassion and generosity. Getting in touch with Emerald is like opening up your inner empath',
    mexicantext:
      "Emeralds from Mexico are vibrant and jewel-like, with bright greens that remind us of springtime. If you're in the market for a classic gem you'll find your heart's desire in Nuovo Leon!",
    braziliantext:
      "Brazilian Emerald may not be as famous as Colombian or Zambian specimens, but it's still a sought-after gemstone for its intense green hue. Minas Gerais is the main source of this gemstone.",
    indiantext:
      'The verdant green hue of Emerald has captivated Indian hearts for centuries. Found mainly in Jharkhand, Rajasthan, and Tamil Nadu, Emerald is believed to cultivate harmony, making this gemstone a perennial favorite among newlyweds, yogis, and spiritual seekers.',
    australiantext:
      'A dark green gemstone with an intense hue, Emerald is known to bring balance and harmony. Perfect for jewelry that offers an alluring touch of sophistication, the best Emeralds from Australia come from Menzies and Emmaville.',
    chakra: 'Heart',
    zodiac: 'Taurus, Gemini',
    bestfor: 'Love, Hope, Compassion',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/emerald',
    green: 'green',
    mexican: 'mexican',
    brazilian: 'brazilian',
    indian: 'indian',
    australian: 'australian',
  },
  {
    title: 'Fluorite',
    img: '',
    description:
      'Fluorite is the family name for some of the best healing crystals commonly available. While most people think Fluorite to be green or purple, it comes in all the colors of the rainbow. For this reason, depending on which type of Fluorite you have, you can use it to activate all of your chakras. A common theme among all Fluorite healing stones is that it boosts mental clarity and clears away brain fog. It’s an amazing stone for concentration',
    chakra: 'All',
    zodiac: 'Capricorn',
    bestfor: 'Clarity, Focus',
    jevelry: 'https://consciousitems.com/collections/fluorite',
    bracelets: 'https://consciousitems.com/collections/fluorite-bracelet',
    rings: 'https://consciousitems.com/collections/fluorite-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/fluorite-meaning-comprehensive-guide',
  },
  {
    title: 'Garnet',
    img: '',
    description:
      "A fiery grounding stone, Garnet connects you to your inner strength and helps you find peace in the present moment. It's one of the best healing crystals for removing negative energy in the bedroom. One of the most powerful crystal meanings for Garnet is related to the masculine and feminine energies, and the divine merging of the two through the art of sex. If you're in need of a libido boost or a burst of passion, Garnet has the right healing properties for you.",
    srilankatext:
      'Sri Lankan Garnet is often found in a medium to dark red color. Mainly from Elahera, these gemstones are highly sought-after for their combination of clarity, vividness, and durability.',
    australiantext:
      'Garnet is a deep red gemstone that symbolizes love and passion. Seek out the perfect Australian Garnet in Broken Hill, Harts Range, and McDonnell Range.',
    chakra: 'Root',
    zodiac: 'Capricorn',
    bestfor: 'Passion, Sexual Energy, Courage',
    jevelry: 'https://consciousitems.com/collections/garnet',
    bracelets: 'https://consciousitems.com/collections/garnet-bracelet',
    rings: 'https://consciousitems.com/collections/garnet-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/garnet',
    srilanka: 'srilanka',
    australian: 'australian',
  },
  {
    title: 'Hematite',
    img: '',
    description:
      "Hematite's healing power can be felt just by holding it. It's a fantastic gemstone for anchoring your energy down and keeping a level head. You can feel the weight of Hematite pulling you down to earth. Hematite is also a powerful protective stone that keeps bad vibes at bay. A stone used by warriors in the ancient past, Hematite has long been associated with blood. Because of this association, it's believed that Hematite assists with high or low blood pressure, circulation of the blood, and the creation of red blood cells.",
    braziliantext:
      'The rusty red color lurking beneath the shiny surface of Brazilian Hematite lends it a special aura. Bahia, Ceará, Goiás, Minas Gerais, Rio Grande do Norte, and Tocantins produce some of the finest specimens of this gemstone.',
    australiantext:
      "There's something elemental about the grey-black tone of Australian Hematite. Its beauty may not be obvious at first, but it has a certain energy that draws people to it. Trek to the Hammersley Range in Western Australia for the best specimens.",
    chakra: 'Root',
    zodiac: 'Aries',
    bestfor: 'Grounding, Protection',
    jevelry: 'https://consciousitems.com/collections/hematite',
    bracelets: 'https://consciousitems.com/collections/hematite-bracelet',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/hematite-stone-meaning',
    grey: 'grey',
    australian: 'australian',
    brazilian: 'brazilian',
  },
  {
    title: 'Iolite',
    img: '',
    description:
      "Known as the Viking's Compass, Iolite is said to guide you towards your desires. Holding this gemstone is like holding a magnet for success. While healing crystals and their meanings are often misunderstood, Iolite is a light in the darkness that helps you pinpoint your purpose with precision. The Iolite meaning is for you to find your meaning. It helps you connect with your inner self, improve your well-being, and follow your intended life path.",
    text: 'This otherworldly gemstone is found across Sri Lanka, though the highest quality specimens are in the Western and North Central Provinces. Iolite from Sri Lanka is distinguished by its deep hues of blue and violet, evoking both opulence and mystery.',
    chakra: 'Third Eye, Throat',
    zodiac: 'Taurus, Libra, Sagittarius',
    bestfor: 'Spiritual Growth, Emotional Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/iolite-meaning',
    blue: 'blue',
    purple: 'purple',
    srilanka: 'srilanka',
  },
  {
    title: 'Jade',
    img: '',
    description:
      "Jade is a gorgeous green crystal, revered by the ancient Chinese and still highly valued to this day. The powerful healing properties of this stone enable it to obliterate negative energy before it has a chance to harm you. One of Jade's lesser known crystal meanings is that it attracts wealth and abundance, ensuring you maintain good control over your finances. Use Jade to absorb negative energy and achieve inner peace.",
    mexicantext:
      'Jade has a long history in Mexico, going back to the Mayan period. Though Jade appears in several different hues, the most common colors converge around shades of green, from vivid emeralds to subtler hues of olive. Chiapas holds some of the most stunning Mexican Jade deposits in the world!',
    australiantext:
      'Renowned for its vibrant green hue and its ability to induce strength and luck, Australian Jade—not to be confused with Aventurine—is mined primarily in Covell and the Eyre Peninsula.',
    chakra: 'Heart',
    zodiac: 'Pisces, Virgo',
    bestfor: 'Self-Love, Compassion, Trust',
    jevelry: 'https://consciousitems.com/collections/jade',
    bracelets: 'https://consciousitems.com/collections/jade-bracelet',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/jade-stone-meaning',
    green: 'green',
    australian: 'australian',
    mexican: 'mexican',
  },
  {
    title: 'Kunzite',
    img: '',
    description:
      "A peaceful crystal for the heart, Kunzite aids you in your quest for self-improvement. Its healing powers promote forgiveness, whether it's for yourself or another – holding a grudge is never a good idea. Kunzite will help you be yourself without worrying about what others will think. It encourages you to value your own happiness more than the opinion of others. Its calming energy is enough to soothe tension and establish emotional balance.",
    text: "Kunzite from Australia may not be a household name but that's only because it's so rare that it's considered a gemstone for connoisseurs. It has an astonishing pink hue, with a craggy texture, and can be found in several areas in Western Australia, such as the Greenbushes Mine and the Greenbushes Tinfield.",
    chakra: 'Heart',
    zodiac: 'Taurus, Scorpio',
    bestfor: 'Peace, Relaxation, Emotional Healing',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/kunzite-stone-meaning-healing-properties',
    pink: 'pink',
    australian: 'australian',
  },
  {
    title: 'Labradorite',
    img: '',
    description:
      "Labradorite is an intense gemstone that has some stunning crystal healing properties. It relieves anxiety and stress, easing tension and encouraging you to relax and truly feel your bodily sensations. It's been known to treat disorders of the eyes, brain, and digestive system. However, its true healing energy comes in the form of spiritual growth. It actively pushes you to follow your sacred calling and get in touch with your higher self. Labradorite's iridescent glitter is thought to open the door between the physical realm and the spirit world.",
    chakra: 'Third Eye, Crown',
    zodiac: 'None',
    bestfor: 'Intuition, Purpose, Spiritual Energy',
    jevelry: 'https://consciousitems.com/collections/labradorite',
    bracelets: 'https://consciousitems.com/collections/labradorite-bracelet',
    rings: 'https://consciousitems.com/collections/labradorite-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/labradorite-ultimate-guide',
    blue: 'blue',
  },
  {
    title: 'Magnesite',
    img: '',
    description:
      "Magnesite is known for being a peaceful crystal. Like many other healing stones of a calming nature, Magnesite is a great stone to use during meditation. It's thought to assist with issues in the bones and teeth. Use Magnesite to find deep inner peace and find comfort in your own silence. It brings stability to the emotions and can align the higher chakras with the lower chakras with its uplifting vibrations.",
    chakra: 'Heart, Crown, Third Eye',
    zodiac: 'Aries',
    bestfor: 'Emotional Healing, Soothing',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/magnesite',
  },
  {
    title: 'Nuummite',
    img: '',
    description:
      'A mystical black and gold stone, Nuummite is a fiery reminder of the natural world. Its physical healing properties are astounding – it relieves pain, supports tissue regeneration, and eases discomfort associated with headaches. Nuummite is a great stone to use if you want relief from stress. This anxiety-busting gemstone can bring a soothing breath of fresh air to even the most stressful of situations. It continues to bring you back to the present moment.',
    chakra: 'Root',
    zodiac: 'None',
    bestfor: 'Grounding, Stress-Relief',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    black: 'black',
  },
  {
    title: 'Obsidian',
    img: '',
    description:
      'A powerful family of stones, Obsidian is a type of volcanic glass that can be found in various dark shades. The most common, Black Obsidian, is a powerful protective stone and provides a fascinating glimpse into the subconscious workings of the mind. Other types of Obsidian such as Snowflake Obsidian or Golden Obsidian work on different areas of the body. These are more suited for ambitious people who are looking for that extra push to get stuff done.',
    mexicantext:
      'This volcanic glass has a deep black exterior with rainbow flashes of color visible through its glossy facets. Obsidian from Mexico has long been a symbol of strength, courage, and protection. Hidalgo is the place to go for premium Obsidian specimens.',
    australiantext:
      "Australian Obsidian has a glassy sheen and, because it's not as dense as Onyx, viewing its delicate markings is a treat. This gemstone can be found in Eastern Australia.",
    chakra: 'Root, Solar Plexus, Third Eye',
    zodiac: 'Scorpio, Sagittarius',
    bestfor: 'Protection, Spiritual Growth',
    jevelry: 'https://consciousitems.com/collections/obsidian',
    bracelets: 'https://consciousitems.com/collections/obsidian-bracelet',
    rings: 'https://consciousitems.com/collections/obsidian-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/obsidian-stone-meaning-types-of-obsidian',
    black: 'black',
    grey: 'grey',
    mexican: 'mexican',
    australian: 'australian',
  },
  {
    title: 'Pearl',
    img: '',
    description:
      "Pearls symbolize inner wisdom and our connection to the cosmos. They bring messages from the divine that help you along your path. A purification master, Pearl is known to dissolve negative energies and keep you in touch with high vibes. While not technically a crystal, Pearl still has extraordinary healing properties. It's brilliant for ensuring a good night's sleep and helping those who suffer from insomnia.",
    australiantext:
      "Though natural Pearls from Australia can still be found in the waters of the Central Coastal region, most of the country's Pearls are now cultured, mainly in the waters of the Northern Territory and Queensland.",
    chakra: 'Crown, Heart, Third Eye',
    zodiac: 'Gemini',
    bestfor: 'Wisdom, Integrity, Purity',
    jevelry: 'https://consciousitems.com/collections/pearl',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/pearl-meaning-symbolism-uses',
    australian: 'australian',
  },
  {
    title: 'Que Sera Stone',
    img: '',
    description:
      'Que Sera Stone is an absolute marvel. It combines the master healing energy of Quartz crystals with Calcite, Feldspar, Magnetite and other high vibe minerals. This mind-bending gemstone is said to be one of the most uplifting energetic tools ever discovered. If you want to pinpoint your true desire, Que Sera Stone will actively focus all of its powerful healing energy into understanding and revealing your desire. It urges you to create your own destiny.',
    chakra: 'All',
    zodiac: 'None',
    bestfor: ' Energy Healing, Positive Energy, Metaphysical Healing, Truth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Rainbow Moonstone',
    img: '',
    description:
      'Rainbow Moonstone has the lunar crystal power to bring stability to the emotions, and firmness to your decisions. As the name suggests, this multi-colored Moonstone activates and aligns all seven major chakras, encouraging a free flow of energy through your body. It boosts the immune system too. Of all the crystal meanings that Rainbow Moonstone has, its most important is that it raises awareness. It encourages you to delve deep into your own psyche and reassess subconscious thoughts, beliefs, and behaviors in a new light.',
    chakra: 'All',
    zodiac: 'Cancer',
    bestfor: 'Emotional Balance, Soothing, Chakra Alignment',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/rainbow-moonstone-meaning',
  },
  {
    title: 'Selenite',
    img: '',
    description:
      "Selenite is a wonder stone for cleansing your environment and charging other crystals. It's a self-cleanser, which means it doesn't even need to be recharged. Despite protecting you and your home frequently from bad vibes, Selenite doesn't absorb negative energy. It transforms it into healing rays of loving light. As a clear crystal, Selenite is also fantastic for providing mental clarity and boosting your intentions.",
    chakra: 'Crown',
    zodiac: 'Taurus',
    bestfor: 'Clarity, Cleansing, Intentions',
    jevelry: 'https://consciousitems.com/collections/selenite',
    bracelets: 'https://consciousitems.com/collections/selenite-bracelet',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/selenite-crystal-meaning',
    white: 'white',
  },
  {
    title: 'Tiger’s Eye',
    img: '',
    description:
      "Activating the seat of personal power, Tiger's Eye is a phenomenal crystal for determination, willpower, and self-belief. If there is a project that you're passionate about, Tiger's Eye will help you see it through to the bitter end. It promotes perseverance and encourages a can-do attitude. You will never give up with this gemstone at your back. It also protects you from the negative intentions of others, and is said to shelter you from the gaze of the evil eye. The most common form of Tiger's Eye predominantly activates the solar plexus chakra, but other variants can open up different chakras.",
    indiantext:
      "It's easy to see why Indian Tiger's Eye is so popular. This eye-catching stone combines the best of both warm and cool colors, creating a mesmerizing display that's as beautiful as it is powerful: Tiger's Eye is believed to zap away any negative energy holding you back. Get the best specimens from Kerala, Orissa, and Kamataka.",
    australiantext:
      "These gems are mainly found in Western Australia's deserts. Australian Tiger's Eye comes in a honey-brown color, almost like wood. Stripes—both light and dark—running across the gem's surface give it its trademark look.",
    chakra: 'Solar Plexus, Third Eye, Root, Throat',
    zodiac: 'Gemini',
    bestfor: 'Protection, Willpower, Self-Belief, Self-Esteem',
    jevelry: 'https://consciousitems.com/collections/tigers-eye',
    bracelets: 'https://consciousitems.com/collections/tigers-eye-bracelet',
    rings: 'https://consciousitems.com/collections/tigers-eye-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/tigers-eye-meaning-healing-properties-uses',
    brown: 'brown',
    indian: 'indian',
    australian: 'australian',
  },
  {
    title: 'Unakite',
    img: '',
    description:
      'A truly beautiful stone, Unakite can be used to merge the emotional and spiritual world. It helps to heal our physical bodies, and has been used in the art of scrying for centuries. Unakite is said to promote inner vision, helping us see our goals as already complete. It also sets sparks flying when it comes to clairvoyance. There are few crystals that can match its pain-relief benefits.',
    chakra: 'Heart, Third Eye',
    zodiac: 'Scorpio',
    bestfor: 'Scrying, Vision, Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/unakite',
  },
  {
    title: 'Vivianite',
    img: '',
    description:
      "Vivianite is a remarkable gemstone that can come in a variety of colors. It's a fantastic healing stone for the physical body, specifically the teeth and bones. Vivianite also prevents memory loss relating to dementia or trauma. A heart-healing crystal, Vivianite is great for finding balance in the heart chakra. It helps you come to terms with your emotions and translate them into conscious actions.",
    chakra: 'Heart, Throat, Third Eye, Crown',
    zodiac: 'Capricorn',
    bestfor: 'Balance, Heart-Healing, Compassion',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/vivianite',
  },
  {
    title: 'White Agate',
    img: '',
    description:
      "White Agate is often said to be the ultimate pregnancy stone. It counters morning sickness and soothes abdominal pain. One of the best healing crystals for the crown chakra, White Agate opens you up to the spiritual realm, helping you become more aware of your thoughts, emotions, and actions. It's a brilliant gemstone for letting go of anger, frustration, or resentment.",
    chakra: 'Crown',
    zodiac: 'Gemini',
    bestfor: 'Pregnancy, Good Fortune, Releasing Anger',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/white-agate-healing-properties',
    white: 'white',
  },
  {
    title: 'Xanthite',
    img: '',
    description:
      'Xanthite stones are rare crystals that belong in the Tourmaline family. Hard gemstones, they can be worn on jewelry and make for great success talismans. These yellow-brown gems banish negative vibes from your aura and encourage you to pursue your dreams. They inspire determination, courage, and self-confidence.',
    chakra: 'Solar Plexus',
    zodiac: 'None',
    bestfor: 'Determination, Courage, Self-Confidence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Yellow Jade',
    img: '',
    description:
      'While not technically a Jadeite stone, Yellow Jade is every bit as powerful as its green namesake. The key difference is that Yellow Jade focuses on the third chakra, the seat of personal power. It helps you form a can-do attitude so that you can set your mind to any task with 100% self-belief. Activating your inner power, Yellow Jade is known to attract prosperity in all your endeavors. Its healing vibrations are fantastic for soothing self-doubt.',
    chakra: 'Solar Plexus',
    zodiac: 'Virgo',
    bestfor: 'Ambition, Perseverance, Self-Belief',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/yellow-jade-guide',
    yellow: 'yellow',
  },
  {
    title: 'Zebra Marble',
    img: '',
    description:
      'Zebra Marble, otherwise known as Zebra Jasper, is a black and white healing crystal that activates both the crown and the root chakras. Zebra stone invites us to observe our own nature, encouraging us to see past the illusion of life. Because of its contrasting colors, Zebra Marble is thought to hold opposing energies: masculine and feminine. By working with this gemstone, you can bring your yin and yang energy into alignment, while simultaneously using the grounding stone for support.',
    chakra: 'Crown, Root',
    zodiac: 'Gemini',
    bestfor: 'Balance, Self-Reflection, Grounding',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Auralite 23',
    description:
      "Auralite 23 has only ever been found in Ontario, Canada, north of Lake Superior. It was named after the 23 minerals that form Auralite 23's crystalline composition. This beautiful crystal has an incredibly high vibration that allows you to connect with the spiritual realm. It opens your mind up to achieving guidance and direction from your higher self and your spirit guides. It also brings clarity to an overactive mind and grounds you in your strength and power. Its combination of 23 minerals makes it one of the most powerful and best-selling crystals to have ever existed.",
    chakra: 'Crown',
    zodiac: 'Aquarius, Pisces',
    bestfor: 'Intuition, Wisdom, Spiritual Growth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Aventurine',
    description:
      'Aventurine brings luck and wealth to its users. Its green color attunes you to opportunity and fortune, allowing you to spot opportunities a mile away. It also places circumstances and people in alignment for your highest good. On top of that, Aventurine is a world-renowned stone used to change the fate and destiny of individuals, especially those who wish to have an influx of wealth and abundance in their lives. Overall, Aventurine is a powerful stone that is not to be underestimated.',
    braziliantext:
      "Brazilian Aventurine is usually mined in various shades of green, which explains its connection to nature and the outdoors. Bahia was the epicenter of the country's Aventurine boom in the mid-1700s, but now you'll find it in several other states.",
    australiantext:
      "Aventurine is a sparkling, translucent quartz that comes in varying shades of green. Believed to bring its wearer good luck, this gem isn't often found in this country, but you can still find decent Australian specimens from time to time—if you're lucky!",
    chakra: 'Heart',
    zodiac: 'Virgo',
    bestfor: 'Luck, Wealth, Good Fortune',
    jevelry: 'https://consciousitems.com/collections/aventurine',
    bracelets: 'https://consciousitems.com/collections/aventurine-bracelet',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/aventurine-crystal-meaning',
    green: 'green',
    brazilian: 'brazilian',
    australian: 'australian',
  },
  {
    title: 'Azeztulite',
    description:
      'Azeztulite infuses feelings of peace and joy in you. It is one of the best crystals for truly experiencing a sense of tranquility, secure in the knowledge that you are one with the Universe. Azeztulite also deepens your meditative state, allowing you to be receptive to the answers that you seek. With it by our side, all the things that you desire will come to fruition. In addition, this beautiful crystal named after one of the star beings also raises our vibrations and allows us to develop a strong positive aura around our energy field.',
    chakra: 'Crown',
    zodiac: 'Leo',
    bestfor: 'Consciousness, Meditation, Peace',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Azurite',
    description:
      'Azurite is the stone of insight. Its energy cleanses and strengthens your emotional body-it inspires you to let go of worries and nagging negative thoughts that linger in the back of your consciousness. It can also give you the ability to understand the root of your fears and phobias, so you can more easily let them go. Its presence may help you overcome behavioral patterns that stem from insecurity and lack of self-worth, teaching you how to love and accept yourself for who you are.',
    chakra: 'Third eye',
    zodiac: 'Taurus, Aquarius, Sagittarius',
    bestfor: 'Insight, Intuition, Intellect',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/azurite',
    blue: 'blue',
  },
  {
    title: 'Azurite-Malachite',
    description:
      'Azurite-Malachite is the powerful combination of Azurite, a stone of insight and intellect, and Malachite, a stone of emotional healing. Together, this stone supports you in the discovery of your deepest self and brings clarity to the purpose of your soul. It also allows you to remain invincible in the presence of threats and danger. Harmonizing the third eye chakra with the heart chakra, this combination also encourages you to maintain a generous spirit while not taking on the burdens and emotions of others.',
    chakra: 'Third eye, Heart',
    zodiac: 'Capricorn, Aquarius, Sagittarius',
    bestfor: 'Insight, Clarity, Emotional Healing',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Barite',
    description:
      'Barite is a great crystal for encouraging you to let go of the things in your life that do not serve you any longer. It allows you to welcome change in your life, and transition smoothly in all your new endeavors. Barite also supports the release of stagnant energy and negative emotions and replaces them with unconditional love. On top of that, it helps us with dream recall and memory retention. It also enables you to open your mind to receiving the wisdom of the Universe.',
    chakra: 'Third eye, Crown',
    zodiac: 'Aquarius',
    bestfor: 'Change, Release, Dream Recall',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    clear: 'clear',
  },
  {
    title: 'Beryl',
    description:
      'Beryl holds within it a myriad of healing properties. It helps you release unhealthy thought patterns and emotional baggage, and replaces these past emotions with bravery and determination. It instills in you a sense of relaxation and peace, a deep knowing that everything is happening just as it should. Beryl also balances empathy with logic and allows you to make the most informed and accurate decisions in your life. After that, it follows up with the motivation and drive to take action where necessary.',
    braziliantext:
      'One of the most expensive gemstones you can find, Beryl from Brazil comes in several vivid colors—including the Golden Beryl, which is ironically one of the most affordable Beryls around. Bahia produces the highest-quality specimens, in our experience.',

    srilankatext:
      "Sri Lanka is the go-to destination for Beryl. The island's gemstone deposits have yielded some of the rarest and highest quality Beryls in the world. From deep blues to bright yellows, Sri Lankan Beryl is sure to please—find your own in the Sabaragamuwa Province or Uva Province!",
    chakra: 'All',
    zodiac: 'Scorpio, Sagittarius, Pisces',
    bestfor: 'Emotional Healing, Relaxation, Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/beryl',
    brazilian: 'brazilian',
    srilanka: 'srilanka',
  },
  {
    title: 'Bismuth',
    description:
      'Bismuth aids in relieving feelings of emotional and spiritual isolation. It also reduces anxiety and depression. In addition, it enhances visualization during shamanic journeying and helps achieve a meditative state. Bismuth also transmutes energy levels at the crown chakra and sends healing kundalini energy to the root chakra. With the ability to improve concentration and stimulate energy, this stone can help you achieve your goals while working in a team.',
    chakra: 'All',
    zodiac: 'Aquarius',
    bestfor: 'Peace, Meditation, Teamwork',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Black Agate',
    description:
      'Black Agate uses its calming energy to keep stress to a minimum. In chaotic households, it helps to keep the peace, dulling negative energy and increasing positive vibrations. It also helps organize the mayhem in your mind and removes energy associated with stress. Disorganized thoughts will be a thing of the past after a while of working with Black Agate. Additionally, it instills in you the motivation needed to pursue your goals. It combines work with intention and focus, thus helping you gain the self-belief needed to propel you into your chosen future.',
    chakra: 'Root',
    zodiac: 'Gemini',
    bestfor: 'Positive Energy, Motivation, Focus',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/what-are-the-black-agate-stone-healing-properties',
    black: 'black',
  },
  {
    title: 'Black Jade',
    description:
      'Black Jade relieves you from negative feelings and replaces these low vibrations with positive emotions and energy instead. Shielding you from negative energy, Black Jade sweeps up bad vibes and deposits them far away from you. If you feel weighed down by malicious forces or negative entities, Black Jade will enhance and elevate your psychic protection, helping you feel safe and secure as you connect with the spiritual world. Black Jade can also be used to help with changing bad habits and self-destructive actions.',
    chakra: 'Root',
    zodiac: 'Taurus',
    bestfor: 'Positive Energy, Protection, Safety',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-jade',
    black: 'black',
  },
  {
    title: 'Black Kyanite',
    description:
      'Known as the revival stone, Black Kyanite is truly a special crystal. It has a high vibration, which translates into the ability to remove blockages quickly, and it is one of the few black stones that cannot store negative energies. Although it is particularly effective for opening the base chakra, it can be used to balance the entire chakra system, keeping the prana - or life force - flowing harmoniously. It can also be used to cleanse and amplify other crystals.',
    chakra: 'Root',
    zodiac: 'Taurus, Libra, Aries',
    bestfor: 'Cleansing, Removing Blockages, Chakra Harmonization',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-kyanite',
    black: 'black',
  },
  {
    title: 'Black Onyx',
    description:
      'Black Onyx is a healer of emotional and mental issues that stem from negativity. While negative emotions are not inherently detrimental, our typical inclination is to use them for harm, whether that means harming others or ourselves (i.e., holding a resentment). Black Onyx does not seek to remove these emotions, but rather to channel them into a greater purpose. Instead of setting the emotions aside, Black Onyx helps you to see them, acknowledge them, accept them, and be present with them without feeling drained or burdened.',
    text: 'The Black Onyx is mysterious and captivating, like a midnight sky. This gemstone is found throughout Mexico, with some of the finest specimens coming from Puebla.',
    chakra: 'Root',
    zodiac: 'Leo, Capricorn',
    bestfor: 'Positive Energy, Channeling, Emotional Healing',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-onyx-ultimate-guide',
    black: 'black',
    mexican: 'mexican',
  },
  {
    title: 'Black Opal',
    description:
      'Black Opal is a powerful protection stone. It absorbs negative energies and can deflect low vibes from its wearer. Black Opal also grounds your energy and brings stability, endurance and grace to you, especially in times of adversity. Due to its rarity and expensive nature, Black Opal is seen as a romantic symbol of "the one". It also supports you in manifesting your wildest dreams, and infuses your body with the most positive, healing energy that will purify and cleanse you.',
    australiantext:
      'The most valuable Australian Opal is the Black variety. Its deep, dark hue stands out among all the other gemstones, and its mystical qualities bring an air of mystery to any collection. Head over to Eastern Australia to find these elusive gems.',
    chakra: 'Root',
    zodiac: 'Libra',
    bestfor: 'Protection, Endurance, Romance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-opal-stone-meaning',
    black: 'black',
    australian: 'australian',
  },
  {
    title: 'Black Sapphire',
    description:
      'Black Sapphire enhances your personal power when you need it the most. In times of adversity and challenge, it brings you the strength, stability and security that you need most. On top of that, it is a great crystal to support you in going through difficult periods of grief and loss. Black Sapphire also attunes you to your highest spiritual power and talents, thus allowing you to make use of your gifts to aid in your manifestation of all things you desire. Its radiating and positive energy will enable you to fulfill your greatest dreams.',
    chakra: 'Root',
    zodiac: 'Taurus',
    bestfor: 'Personal Power, Strength, Manifestation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-sapphire',
    black: 'black',
  },
  {
    title: 'Black Tourmaline',
    description:
      'Black Tourmaline is a protective, grounding stone known for its ability to absorb negative energy. It acts as an absorbent shield, making it an excellent talisman for turning positive vibrations into strong energy within your emotional body, thus giving you a deeper sense of well-being. When you are faced with something that could emotionally drain you, Black Tourmaline volunteers itself as a place for that negativity to reside in. It’s even able to channel some of that negativity into positive, useful energy.',
    chakra: 'Root',
    zodiac: 'Libra, Scorpio',
    bestfor: 'Protection, Grounding, Positive Energy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-tourmaline-meaning-healing-properties',
    black: 'black',
  },
  {
    title: 'Bloodstone',
    description:
      "An essential part of maintaining your energetic system and keeping it in tip-top shape involves regularly clearing any sluggish or negative energy from your environment. Bloodstone is an ideal healing crystal for this purpose. It is an excellent purifying stone, banishing negativity with ease, and working to protect your energy field. It is also an excellent crystal for grounding yourself. If you've had trouble staying focused or often feel too busy, you could benefit from Bloodstone's stabilizing energy.",
    chakra: 'Root',
    zodiac: 'Pisces, Aries, Libra',
    bestfor: 'Purification, Protection, Stability',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/bloodstone',
    green: 'green',
  },
  {
    title: 'Blue Apatite',
    description:
      'Blue Apatite helps you come to terms with your emotions. A brilliant gemstone for personal growth, Blue Apatite is there to help you progress. To do so, you will need to let go of emotions that are no longer serving you, which this beautiful crystal is excellent for. Blue Apatite also holds a reputation for being a great stone of ambition and motivation. As a blue stone, Blue Apatite also implores you to search within and express your authentic self honestly to the world.',
    chakra: 'Third eye',
    zodiac: 'Gemini',
    bestfor: 'Progress, Ambition, Honesty',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-apatite',
    blue: 'blue',
  },
  {
    title: 'Blue Aventurine',
    description:
      "Blue Aventurine is a great crystal to instill a sense of confidence and calmness in you. These feelings will allow you to work on your tasks and complete your projects with greater ease. It also brings inspiration that can help you overcome obstacles in your path such as writer's block or other challenges. Blue Aventurine's energy also promotes confidence in public speaking and in communicating effectively with anyone on your journey. It also heightens awareness of the angelic realm.",
    chakra: 'Throat',
    zodiac: 'Aquarius, Libra',
    bestfor: 'Confidence, Communication, Calmness',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    blue: 'blue',
  },
  {
    title: 'Blue Calcite',
    description:
      'Blue Calcite sharpens intuition and psychic insight. It connects you to your higher self and to your subconscious mind. That is why it can help you process and transmute negative energies from your past lives as well as from your current human experience. After processing those negative vibrations, you will raise your vibration and make progress on your path. Because of this, Blue Calcite is a symbol of spiritual growth and development that enhances your ability to communicate and overcome social anxiety.',
    chakra: 'Throat',
    zodiac: 'Cancer',
    bestfor: 'Social Anxiety, Spiritual Growth, Communication',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-calcite-meaning',
    blue: 'blue',
  },
  {
    title: 'Blue Chalcedony',
    description:
      'Blue Chalcedony helps you express yourself eloquently and fluently. It allows you to tap into your innermost emotions and feelings, and communicate them in a way that stays true to you. It also promotes harmony in relationships, where everyone has an equal footing and feels comfortable sharing their thoughts and opinions with each other. In addition, Blue Chalcedony connects you to your highest confidence and courage, therefore enabling you to stand up for yourself in every situation. Its gentle energy eases stress and enhances peace and tranquility.',
    chakra: 'Throat',
    zodiac: 'Gemini',
    bestfor: 'Communication, Peace, Tranquility',
    jevelry: 'https://consciousitems.com/collections/chalcedony',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Black Obsidian',
    img: '',
    description:
      'Black Obsidian is a powerful protective stone. Its grounding energy roots you to mother earth, ensuring your inner strength is activated at all times. It helps you find security and stability in any situation. A standout benefit of Black Obsidian’s healing properties is that it encourages introspection – it was used in scrying mirrors for centuries. This deep soul cleanser promotes self-reflection and enables you to pinpoint your own bad habits; negative thoughts, beliefs, or subconscious actions; and root causes of issues. This, in turn, empowers you to overcome your flaws one at a time.',
    chakra: 'Root',
    zodiac: 'Sagittarius, Scorpio',
    bestfor: 'Protection, Grounding Energy, Self-Reflection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/black-obsidian-stone-meaning',
    black: 'black',
  },
  {
    title: 'Blue Fluorite',
    description:
      'Blue Fluorite brings a stable and balancing energy that helps you to calm your overactive mind. It encourages you to make informed decisions from a space of calmness. Blue Fluorite is also an excellent crystal for removing any doubt, question, or confusion about the future, and instills in you a strong sense of trust that everything will work out. In facing the truth, it gives you courage and confidence. Moreover, Blue Fluorite taps into divine energy to lead you on the path towards your highest self and potential.',
    chakra: 'Throat, third eye',
    zodiac: 'Pisces, Gemini, Leo, Capricorn',
    bestfor: 'Calmness, Confidence, Truth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-fluorite',
    blue: 'blue',
  },
  {
    title: 'Blue Jade',
    description:
      'Blue Jade allows you to step into the unknown with confidence and an even temper. It removes the tendency to be overwhelmed and stressed, and enhances rational thought and intelligence. Known as a Dream Stone, this beautiful blue crystal opens you up to receiving important messages from the Universe in your dreams. It also helps with dream recall and dream interpretation. Blue Jade is especially useful when faced with self-inflicted barriers to success.',
    chakra: 'Throat, third eye',
    zodiac: 'Taurus',
    bestfor: 'Rational Thought, Dreaming, Insight',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    blue: 'blue',
  },
  {
    title: 'Blue John Fluorite',
    description:
      'Blue John Fluorite infuses in you the spirit of personal development and growth. It attunes you to the changes you need to make in your life and ensures that you are on the right path at all times. It also brings a deep sense of peace and awakens the mind to new possibilities. When you encounter confusion or stress, Blue John Fluorite is a great crystal to have by your side, as it brings you the answers that you seek. In addition, this rare crystal encourages us to attain a more positive outlook towards groups and communities.',
    chakra: 'Throat, third eye',
    zodiac: 'Pisces',
    bestfor: 'Growth, Change, Possibility',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Blue Lace Agate',
    description:
      'Blue Lace Agate teaches you not to hold yourself back, whether that involves hesitating to turn over a new leaf or not showing up in a truly authentic way. It encourages you to endure rejection and criticism with grace, and encourages you not to dwell on any past judgments from yourself or others. Its light blue coloring hints at its ability to help you feel calm and find emotional balance and harmony in your life. If you find yourself feeling frustrated or unable to process anger constructively, this crystal may be what you’re looking for.',
    text: 'Arrestingly beautiful, Blue Lace Agate is characterized by its pale blue and white patterns that often resemble lace or ruffles. Though Sri Lankan Blue Lace Agate specimens are found sometimes in Sri Lanka, the country has yet to find a significant deposit of this stunning gemstone.',
    chakra: 'Throat',
    zodiac: 'Gemini, Pisces',
    bestfor: 'Authenticity, Criticism, Emotional Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-lace-agate',
    blue: 'blue',
    srilanka: 'srilanka',
  },
  {
    title: 'Blue Obsidian',
    description:
      'Blue Obsidian is widely known for its ability to enhance your communication skills. It helps to aid self-expression and improve self-awareness. It is an excellent aid for removing imposter syndrome and allows you to embrace your authentic self. It also encourages vocal fluidity and boosts your confidence to speak out more. Blue Obsidian also grants you the ability to ground yourself in your emotional strength. It helps you to look inward as you practice self-acceptance and discover your true self.',
    chakra: 'Throat',
    zodiac: 'Pisces',
    bestfor: 'Communication, Self-Expression, Emotional Strength',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-obsidian',
  },
  {
    title: 'Blue Quartz',
    description:
      'Blue Quartz brings to you the energy of a deep and calm ocean. It helps you achieve a deeper level of emotional healing. When you use Blue Quartz, you can explore your subconscious mind. Fears and unresolved issues will come to the surface so you can resolve them. In addition, if you have been dealing with issues related to your authentic self, wearing a Blue Quartz crystal will support your self-expression. It also has the power to anchor you in the present moment.',
    chakra: 'Throat, third eye',
    zodiac: 'Aquarius',
    bestfor: 'Calmness, Emotional Healing, Self-Expression',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/practice/blue-quartz-meaning',
    blue: 'blue',
  },
  {
    title: 'Blue Sandstone',
    description:
      'Blue Sandstone means new beginnings and success. You can use it to fuel your ambition or new business ventures. You can also use Blue Sandstone to manifest your intentions. This crystal balances your chakras to facilitate self-acceptance, relieve stress, help you speak your truth freely, and increase focus. In addition, it is a powerful protection stone that deflects negative energy and shields your auric field from unwanted vibrations. Its vibration instills positive energy, boosts your mood, and uplifts your spirit.',
    chakra: 'Throat, third eye',
    zodiac: 'Sagittarius',
    bestfor: 'New Beginnings, Success, Ambition',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    blue: 'blue',
  },
  {
    title: 'Blue Tiger’s Eye',
    description:
      "Blue Tiger’s Eye reduces stress and overwhelment in your body and allows you to emerge from a mentally exhausted state of mind. Before you settle into a meditation practice, take a moment to grab this soothing stone to invite its tranquil energy into your life. The energy of Blue Tiger's Eye will encourage you to release the tension in your life, find emotional balance, and achieve greater mental clarity. In addition, Blue Tiger’s Eye helps you turn over a new leaf and improve your communication.",
    chakra: 'Third eye, throat',
    zodiac: 'Leo, Capricorn',
    bestfor: 'Stress, Balance, Communication',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-tigers-eye',
  },
  {
    title: 'Blue Topaz',
    description:
      "Blue Topaz is an excellent stone that encourages you to express yourself honestly and openly, and that supports you on your journey of self-reflection and personal growth. It also wards off negative energies, thoughts and emotions. Its soothing energy is said to balance emotions or mood swings, especially if you need to release deep-seated anger. Blue Topaz's mystic vibration is believed to help you understand your emotions and learn from them, teaching you that all emotions play an essential part in your life and self-growth journey.",
    text: "Brazil is the main producer of Topaz in the world. 'Precious' Topaz has a golden hue, while 'Imperial' Topaz comes in shades of pink, purple, or red. Minas Gerais is a wonderland for dedicated Topaz hunters.",
    chakra: 'Throat',
    zodiac: 'Aquarius',
    bestfor: 'Honesty, Growth, Emotional Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-topaz',
    blue: 'blue',
    brazilian: 'brazilian',
  },
  {
    title: 'Blue Tourmaline',
    description:
      'Blue Tourmaline attunes you to the spiritual world. With it by your side, you will experience spiritual gifts of insight and prophecy. You will also receive messages of divine wisdom and be protected from harmful energetic barriers. Moreover, Blue Tourmaline heals you from the deep sadness that you have been holding inside you, especially when you cannot rely on justice for closure. It heals wounds that have been in you since childhood, and helps you in sleeping peacefully at night.',
    chakra: 'Third eye',
    zodiac: 'Libra',
    bestfor: 'Spirituality, Insight, Closure',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/blue-tourmaline-meaning',
    blue: 'blue',
  },
  {
    title: 'Botswana Agate',
    description:
      'Botswana Agate is a great crystal to use when looking to cope with grief and other intense negative emotions. A comfort stone, Botswana Agate has a calming vibration that alleviates feelings of depression, anxiety, and grief. It also reduces the body’s tendency towards panic attacks and psychic attacks. It encourages you to look ahead in life, towards more positive and hopeful events, rather than being stuck in old, negative vibrations and emotions. In addition, Botswana Agate is often used by artists to express themselves in a creative way.',
    chakra: 'Root',
    zodiac: 'Gemini',
    bestfor: 'Grief, Depression, Emotional Healing',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/botswana-agate',
    grey: 'grey',
  },
  {
    title: 'Brandberg Amethyst',
    description:
      'Brandberg Amethyst returns the body’s emotional field to its original state and its highest vibration. Bringing pure and healing energy, it envelops you with compassion and forgiveness, thus allowing you to move forward with peace. With this gorgeous crystal by your side, you will be able to embrace the relationships and situations in your life with greater peace and harmony. In addition, Brandberg Amethyst connects you to the truest existence of your soul, releasing sadness and replacing it with joy.',
    chakra: 'Crown',
    zodiac: 'Pisces',
    bestfor: 'Compassion, Peace, Joy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Brilliant Emerald',
    description:
      'Emerald enhances unconditional love, unity, and loyalty. It is known to bring harmony to all areas of one’s life by promoting physical, emotional, and mental equilibrium. Symbolizing renewal, growth, and hope, Emerald seeks to spread love and reveal the truth in the ever-constant search for meaning in life. A stone of aspiration and inspiration, Emerald sustains one’s spiritual journey. It also raises your consciousness by eliminating negative energy in your body and enhancing your ability to enjoy life to the fullest.',
    chakra: 'Heart',
    zodiac: 'Gemini, Cancer, Taurus',
    bestfor: 'Love, Balance, Spirituality',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/emerald',
  },
  {
    title: 'Bronzite',
    description:
      "Bronzite is the perfect companion for you if you need a boost of confidence and self-esteem. It has the ability to keep you grounded and present, spark your creativity, and empower you to go after the things you want in life. Bronzite also gives you the courage to act in accordance with your thoughts and feelings, and with the confidence that you're making the right decisions for yourself and your life. Its earthly energy promotes clarity, especially in situations where you might feel overwhelmed or powerless.",
    chakra: 'Root',
    zodiac: 'Leo',
    bestfor: 'Confidence, Clarity, Self-Esteem',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/bronzite',
  },
  {
    title: 'Brown Jasper',
    description:
      'Brown Jasper brings grounding and stability to the emotional and physical body. It helps you alleviate feelings of stress and anxiety, and brings forth a calm and collected sense of security. It also encourages you to be more compassionate and patient to the people around you. With Brown Jasper’s centering vibration near you, you will find yourself becoming more generous and less worried about losing power or material possessions. In addition, Brown Jasper instills in you a sense of bliss and peace.',
    chakra: 'Root',
    zodiac: 'Cancer, Capricorn, Aries, Scorpio',
    bestfor: 'Contentment, Grounding, Calmness',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/brown-jasper-meaning',
    brown: 'brown',
  },
  {
    title: 'Cacoxenite',
    description:
      'Cacoxenite infuses in you an overflowing sense of peace and calmness. In times of distress, this powerful crystal has the ability to help you discover and overcome the root causes of your deepest negative emotions. In addition, it encourages you to release the negative bonds that keep you bound to negative events in the past. In doing so, you will be more attuned to the vibrations of your highest self. Cacoxenite also grants you greater awareness of the spiritual realm, accessible through deep meditation.',
    chakra: 'Crown',
    zodiac: 'Sagittarius',
    bestfor: 'Peace, Attunement, Spirituality',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    purple: 'purple',
  },
  {
    title: 'Calcite',
    description:
      'Calcite gives you the ability to discern which pieces of information are the most important. This can keep your energy calm and collected whenever you feel provoked. It also allows you to study more effectively and transform your ideas into actions. This crystal also combats feelings of laziness and gives you bursts of energy to accomplish things and enjoy life to the fullest. It eases the emotional stress that you may be feeling and replaces that feeling with peace. Known as a stabilizing stone, it increases your ability to trust others and yourself.',
    chakra: 'All',
    zodiac: 'Cancer',
    bestfor: 'Discernment, Drive, Stability',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/calcite-crystal-meaning',
  },
  {
    title: 'Calcite Golden',
    description:
      'Golden Calcite is a honey-colored crystal that is responsible for supporting you through difficult times and adversity. This is especially helpful if you have gone through abusive relationships or trauma in the past. In addition, Golden Calcite is also a great crystal for encouraging you to take on greater ownership and power in your career and business. Instilling in you a sense of confidence and self-esteem, Golden Calcite aids you in picking up and honing your talents and skills.',
    chakra: 'Throat',
    zodiac: 'Cancer, Libra, Leo',
    bestfor: 'Adversity, Confidence, Responsibility',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Celestite',
    description:
      'Celestite connects you to the angelic realms. It opens you up to receiving information from higher beings and can put you in contact with your guardian angels. Widely considered as the best gemstone for pursuing spiritual strength, Celestite connects you to the divine nature of everything. Like entering a vortex of cosmic knowledge, Celestite has the ability to temporarily transport your awareness to a non-physical plane where everything seems to make sense, despite its complex intricacies.',
    chakra: 'Throat',
    zodiac: 'Libra, Gemini',
    bestfor: 'Spirituality, Awareness, Strength',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/celestite-crystal-meaning',
  },
  {
    title: 'Cerussite',
    description:
      'Cerussite attunes you to higher states of wisdom and insight, thus allowing divine messages to come through and aid you in your physical states of reality. It is also known to be useful in releasing grudges and negative thought patterns from the past, thereby encouraging you to live in the present moment. Moreover, Cerussite is a great crystal for easing feelings of anxiety in you and teaching you that there is only the present. It also brings logic and intellect that aid in your decision making processes.',
    chakra: 'Root',
    zodiac: 'Virgo',
    bestfor: 'Wisdom, Letting Go, Logic',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Chalcedony',
    description:
      'Chalcedony is known for its nurturing abilities and its ability to promote comradery. It instills feelings of generosity in you and rids your body and mind of hostility. It also diminishes feelings of self-doubt or self-pity. Chalcedony is also a powerful crystal to combat the build-up of negativity and toxins in your physical and emotional body. It cleanses the body of unhealthy elements and restores it to its original, high vibrational state. With this crystal by your side, you will also be able to align your physical and mental states.',
    braziliantext:
      "Another type of Quartz, Chalcedony is marked by its translucence and its single-color tone. Brazilian Chalcedony comes in light bluish tones, bordering on violet. The best specimens we've found all come from Rio Grande do Sul and Paraná.",
    australiantext:
      "Chalcedony is a milky-white to light-grey colored gemstone with a waxy sheen. If you're a fan of Australian Chalcedony, you'll be glad to know it can be found all over the country.",
    chakra: 'Throat',
    zodiac: 'Cancer, Sagittarius',
    bestfor: 'Nurture, Generosity, Alignment',
    jevelry: 'https://consciousitems.com/collections/chalcedony',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/chalcedony-stone',
    blue: 'blue',
    brazilian: 'brazilian',
    australian: 'australian',
  },
  {
    title: 'Charoite',
    description:
      'Charoite is one of the best crystals for people who struggle to reach deep levels of sleep, due to insomnia or nightmares. Its cleansing energies do a great service to your physical body while you sleep, and they help to soothe your emotional energies so that you can drift off easier and wake up feeling refreshed. Charoite is particularly useful for activating the upper chakras, specifically the crown chakra and third eye chakra. When it stimulates these areas of the spiritual body, it brings your psychic powers to the surface.',
    chakra: 'Crown, third eye',
    zodiac: 'Capricorn, Scorpio, Aries',
    bestfor: 'Sleep, Cleansing, Psychic Abilities',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/charoite',
    purple: 'purple',
  },
  {
    title: 'Chrysocolla',
    description:
      'Chrysocolla emphasizes the power your words and actions have on the people around you, especially within your relationships. It cools down tempers and dispels negative energies during rocky periods with your partner, thus creating an open channel of communication to find common ground and reach solutions together. It is very beneficial for those who speak or perform in public, giving them the confidence to show up to the world as their true selves. It has a stimulating effect on your mind, yet it relaxes your emotions.',
    text: 'The best Chrysocolla from Australia come in vivid green or blue patterns, which arise from the interplay of this gem with other minerals found in the area. Southern Australia and New South Wales have several mines and deposits from which to choose your perfect Chrysocolla.',
    chakra: 'Throat',
    zodiac: 'Sagittarius',
    bestfor: 'Self-Expression, Communication, Public Speaking',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/chrysocolla',
    australian: 'australian',
  },
  {
    title: 'Chrysoprase',
    description:
      "Chrysoprase’s energy offers hope and assists your heart in preparing for new love and new relationships. It promotes joy, happiness, and above all, forgiveness. It is a token that empowers you to become more confident and independent and take control of your life. Chrysoprase’s cleansing vibration alleviates mental exhaustion and helps to keep a clear mind during challenging times. It is a wonderful amulet to remind you of the talents and gifts you possess, and it inspires you to use them to create the life you've always wanted.",
    text: 'Chrysoprase is a light green gemstone that is said to promote joy and bring good luck. Chrysoprase from Australia is sourced from several areas, the most notable ones being Mt. Davis and the Marlborough Deposit, located in Queensland.',
    chakra: 'Heart',
    zodiac: 'Gemini, Aquarius',
    bestfor: 'Hope, Forgiveness, Confidence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/chrysoprase',
    australian: 'australian',
    green: 'green',
  },
  {
    title: 'Citrine',
    description:
      'Citrine is terrific for spaces that need to be cleansed of negative energies and spirits. Not only does it release tension in your emotional body and allow you to let go of anger, but it also overcomes feelings of confusion, depression, and fear. Citrine also increases your self-worth, allowing you to take criticism gracefully. It is also known to help with relationships and attract pleasure into your life. On top of that, it attunes you to vibrations of wealth and abundance, thus bringing prosperity into your life.',
    indiantext:
      'Yellow-orange Citrine from India is the epitome of joy and enthusiasm. Known for its ability to promote optimism and draw out your sunny disposition, Indian Citrine comes mainly from Telangana.',
    australiantext:
      'A perky yellow gemstone, Citrine is known for its cheerful energy. Found mainly in Kingsgate, in New South Wales, Australian Citrine is prized for its bright, enervating hue.',
    srilankatext:
      'Citrine is found throughout Sri Lanka, in hues ranging from golden yellow to burnished orange. The Sabaragamuwa Province is widely considered the best place to find Citrine—this is where you can find the most intense and vibrant specimens.',
    braziliantext:
      'Citrine is the golden-yellow variety of Quartz. Found in abundance in Brazil, Citrine is one of the most affordable gems in the market. We recommend Rio Grande do Sul as a great source for quality Brazilian Citrine.',
    chakra: 'Solar plexus, sacral',
    zodiac: 'Aries, Leo, Libra',
    bestfor: 'Wealth, Abundance, Pleasure',
    jevelry: 'https://consciousitems.com/collections/citrine',
    bracelets: 'https://consciousitems.com/collections/citrine-bracelet',
    rings: 'https://consciousitems.com/collections/citrine-ring',
    link: 'https://consciousitems.com/blogs/lifestyle/citrine-stone',
    orange: 'orange',
    yellow: 'yellow',
    indian: 'indian',
    australian: 'australian',
    srilanka: 'srilanka',
    brazilian: 'brazilian',
  },
  {
    title: 'Clear Quartz',
    description:
      'Clear Quartz is often regarded as one of the oldest and most enlightening gemstones in the world. It is brilliant for enhancing mental clarity, and serves as the perfect tool for increasing quick wit, rational thinking, and focus. It dispels negative energy and supercharges the intentions you set for it. It is known for connecting with you on a deeper level and intensifying your energy. On top of that, Clear Quartz deepens your meditative state and quietens your thoughts with its mind-stilling effects.',
    australiantext:
      'Just as in the rest of the world, Quartz is one of the most common gemstones found in Australia. We recommend Kingsgate, a little town in Northern New South Wales, as the best place to find the perfect Australian Quartz for you.',
    chakra: 'Crown',
    zodiac: 'Aries',
    bestfor: 'Clarity, Focus, Meditation',
    jevelry: 'https://consciousitems.com/collections/clear-quartz',
    bracelets: 'https://consciousitems.com/collections/clear-quartz-bracelet',
    rings: 'https://consciousitems.com/collections/clear-quartz-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/clear-quartz-meaning-and-healing-properties',
    clear: 'clear',
    australian: 'australian',
  },
  {
    title: 'Dalmatian Jasper',
    description:
      'Dalmatian Jasper appeals to those who need to bring more happiness and higher vibes into their lives. It symbolizes reviving connections that have been overtaken by routine and jadedness. Dalmatian Jasper also helps repel negative vibes. It has a calming influence on any emotional state and helps you overcome any negative thoughts or negative feelings that you might be struggling with. In addition, it can be used as a passion stone to intensify sexual pleasure and the sense of deep connection between partners.',
    chakra: 'Root',
    zodiac: 'Virgo',
    bestfor: 'Happiness, Calmness, Passion',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Dolomite',
    description:
      'Dolomite has been known to bring harmonious energy to all things natural. It can also restore your own energy if you find yourself with more-than-usual frantic energy or if you have been feeling low. A beacon of hope for those grieving or wallowing in sorrow, Dolomite can help pick you back up from off the floor. It releases feelings of selfishness and helps you see the abundant side of life, harnessing your manifestation powers and opening your heart back up to accepting the trueness you deserve in life.',
    chakra: 'All',
    zodiac: 'Aries',
    bestfor: 'Harmony, Hope, Manifestation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/a-guide-to-dolomite',
  },
  {
    title: 'Epidote',
    description:
      "Epidote is a helpful stone for creating more prosperity and abundance. Whether it's finding cash for investments or drawing fateful situations into your orbit, as long as you're taking action, Epidote can magnify your efforts. It can also help you transmute lower energies into more positive ones, and enhance your thoughts, speech, and actions. When you're ready to roll up your sleeves and shift things for the better, Epidote helps put an end to procrastination and other behaviors that cause more harm than good.",
    chakra: 'Heart',
    zodiac: 'Gemini',
    bestfor: 'Abundance, Action, Transformation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/epidote',
  },
  {
    title: 'Fuchsite',
    description:
      "Fuchsite is one of the best crystals to help you balance your mind and emotions. It encourages you to use your mental gifts while letting your heart guide you. When you achieve this delicate equilibrium, you're able to navigate your life according to your principles and invest your precious time in things that make your soul sing. Its energy can reduce the tendency to self-neglect. It teaches you that you first need to love and take care of yourself, so you can better take care of others.",
    chakra: 'Heart',
    zodiac: 'Aquarius',
    bestfor: 'Balance, Principles, Self-Care',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/fuchsite',
  },
  {
    title: 'Goldstone',
    description:
      'Red Goldstone promotes a positive attitude and attracts wealth into your life. You can make your wildest dreams come true and experience the deepest passions when guided by the light of the Reddish-Brown Goldstone since it works with your creative sacral chakra and your passionate base chakra. Blue Goldstone can stimulate your ability to be persuasive and charismatic. Green Goldstone attracts compatible potential partners and opens up their hearts to you. It also opens up your heart to theirs, thus creating a close emotional connection.',
    chakra: 'Root, throat',
    zodiac: 'Leo, Sagittarius',
    bestfor: 'Positivity, Passion, Charisma',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/goldstone-meaning-5-amazing-goldstone-properties',
  },
  {
    title: 'Green Aventurine',
    description:
      'Referred to as the "Stone of Opportunity," the Green Aventurine stone is considered one of the luckiest crystals. It promotes a feeling of forgiveness and acceptance of human nature. In this way, it is very beneficial for all those who experience fear, anxiety, and restlessness. Green Aventurine is considered a positive stone, symbolizing inner peace, curbing negative energy, and promoting spiritual growth. It also aligns your vibration with that of Mother Nature, and encourages you to engage in personal growth.',
    chakra: 'Heart',
    zodiac: 'Libra',
    bestfor: 'Opportunity, Luck, Personal Growth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/green-aventurine-meaning',
    green: 'green',
  },
  {
    title: 'Green Calcite',
    description:
      'Green Calcite helps you accept yourself and all your imperfections. You’ll overcome destructive behaviors and embrace positive change. Through a process of self-discovery, you will invite good energies into your life. It’s the perfect stone for building a stronger sense of your true personal power. You will achieve a sense of true happiness as you release all negative energies from your emotional body. Manifesting good luck and abundance will come much easier with the help of Green Calcite.',
    chakra: 'Heart',
    zodiac: 'Cancer, Virgo, Capricorn',
    bestfor: 'Self-Discovery, Change, Personal Power',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/green-calcite',
    green: 'green',
  },
  {
    title: 'Green Fluorite',
    description:
      'Green Fluorite is used for balancing and stabilizing the spirit, soul, and body. It is the great harmonizer, making sense of confusion and helping to organize and reframe your thoughts. It also restores order and promotes peace in the mind, body, and environment. Often referred to as the “genius stone,” Green Fluorite has a strong connection to intelligence and mental aptitude. This stone helps you hear new concepts, ideas, and information and process it with better understanding and retention.',
    chakra: 'Heart',
    zodiac: 'Pisces',
    bestfor: 'Balance, Stability, Intelligence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/green-fluorite-meaning-expert-guide',
    green: 'green',
  },
  {
    title: 'Howlite',
    description:
      'Howlite promotes calmness, peace, deep reflection, and tranquility. It helps you grow spiritually by placing you in a position of calm acceptance and quieting your spirit. It also allows you to deepen your meditative state and balance and activate your crown chakra. On top of that, Howlite promotes self-reflection, free from narcissism or negativity. It allows you to look deeply at your personal truth and gives you the courage to make adjustments where needed. It is often used to regulate the temper and is useful in promoting better self-tolerance and acceptance.',
    chakra: 'Crown',
    zodiac: 'Gemini',
    bestfor: 'Calmness, Meditation, Self-Reflection',
    jevelry: 'https://consciousitems.com/collections/howlite',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/howlite-meaning-comprehensive-guide',
    blue: 'blue',
  },
  {
    title: 'Jasper',
    description:
      'Red jasper awakens your kundalini and removes blockages in your base chakra. It is an excellent stone to work with when you’re craving more focus and a boost of motivation. Rainforest jasper is the perfect gemstone when you want to deepen the connection you have to yourself and your life. It can help instill a greater sense of self-love and compassion. Picture Jasper invites feelings of stability and balance into your life. Orbicular Jasper allows you to start afresh without doubts and uncertainty.',
    text: "One of the most common gemstones in the country, you'd have a hard time avoiding Australian Jasper if you go on a hunt. It has a lovely mottled appearance with various colors and can be found all over the land.",
    chakra: 'Root',
    zodiac: 'Cancer',
    bestfor: 'Balance, Motivation, Connection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/jasper',
    australian: 'australian',
  },
  {
    title: 'Kambaba Jasper',
    description:
      'Kambaba Jasper instills in you a sense of pure love and compassion. It grounds you in your ability to treat others with kindness, instead of judging them based on preconceived notions or stereotypes. It also brings stability and balance to your emotional body, allowing you to embrace a state of calmness and tranquility. In addition, Kambaba Jasper encourages you to act with courage and step outside your comfort zone to achieve your heart’s greatest desires. It also brings wisdom to aid you on that path.',
    chakra: 'Heart',
    zodiac: 'Scorpio',
    bestfor: 'Compassion, Balance, Courage',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Kyanite',
    description:
      'Kyanite is a stone of connection, healing, clear thinking, and psychic ability. It aligns the chakras and brings harmony and balance. It is an excellent stone for meditation. Blue Kyanite’s calming energy brings insight to your mind, while Green Kyanite connects you to nature and to your own personal development. Indigo Kyanite awakens psychic abilities like telepathy and clairvoyance, and Black Kyanite protects you from negative energy. In addition, Orange Kyanite enhances passion and creativity.',
    chakra: 'All',
    zodiac: 'All',
    bestfor: 'Insight, Personal Development, Creativity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/kyanite-crystal-meaning',
    blue: 'blue',
  },
  {
    title: 'Lapis Lazuli',
    description:
      'Lapis Lazuli reveals inner truth and encourages the release of repressed anger and other negative emotions. It also helps you in building healthy social connections and relationships with others. On top of that, Lapis Lazuli promotes empathy and is considered to be one of the best crystals for empaths. Used in ancient Persia to symbolize the night sky, it allows you to be honest with other people and maintain harmonious relationships without conflict. It also stimulates psychic abilities and aids in enhancing compassion for others.',
    text: "Imagine looking up at a night sky and seeing stars twinkling against the inky blackness—that's the energy Lapis Lazuli evokes. Australian Lapis Lazuli is rightly famed for its deep blue color, and is found all over Western Australia.",
    chakra: 'Third eye',
    zodiac: 'Sagittarius',
    bestfor: 'Truth, Relationships, Harmony',
    jevelry: 'https://consciousitems.com/collections/lapis-lazuli',
    bracelets: 'https://consciousitems.com/collections/lapis-lazuli-bracelet',
    rings: 'https://consciousitems.com/collections/lapis-lazuli-ring',
    link: 'https://consciousitems.com/blogs/lifestyle/lapis-lazuli-stone',
    blue: 'blue',
    australian: 'australian',
  },
  {
    title: 'Larimar',
    description:
      "Associated with the throat chakra, Larimar is excellent at increasing your communication skills. It empowers you to find the right words to express your inner wisdom in the most articulate way possible. It provides the courage to speak from the heart and is often used to amplify your voice. In addition, Larimar is a great crystal to help you spot the limitations you've imposed upon yourself.It lifts the veil and helps you glimpse the truth on the other side.It also frees you from emotional inhibitions that seek to keep you in perpetual discomfort.",
    chakra: 'Throat',
    zodiac: 'Pisces, Leo',
    bestfor: 'Communication, Courage, Truth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/larimar',
    blue: 'blue',
  },
  {
    title: 'Larvikite',
    description:
      'Larvikite is a protective and grounding stone that protects you and dispels negative energy. It helps ground your strength, reconnect you to the Earth’s power, and attune you to nature spirits. Larvikite also evokes inner strength by stimulating creativity, wisdom, and security in your intellect. Commonly used in meditation to produce inner visions, it is known to enhance psychic abilities, helping us see ourselves through the perspective of our higher self. The grounding energy of Larvikite makes it ideal for meditation and astral travel.',
    chakra: 'Root',
    zodiac: 'Aquarius',
    bestfor: 'Grounding, Strength, Vision',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/larvikite',
  },
  {
    title: 'Leopard Skin Jasper',
    description:
      'Leopard Skin Jasper is a wonderful stone that holds many emotional healing properties. A powerful protection stone, this beautiful stone supports us in personal growth endeavors and self healing. It brings harmonious vibrations to our aura and can overcome weakness. Leopard Skin Jasper is a great companion stone to support the nurturing of your inner child. On top of that, it is a supreme nurturer that allows us to be grounded in our body experiences while balancing and stabilizing our energy fields.',
    chakra: 'Root',
    zodiac: 'Gemini, Scorpio',
    bestfor: 'Protection, Personal Growth, Stability',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Lepidolite',
    description:
      'Lepidolite is a stone of emotional healing and balance. It has the power to dispel low vibrational emotions like anger, grief and sadness. It is also a stone of transition, facilitating change and transition through switching jobs, relocation or marriage. It stabilizes your emotions and connects you to your inner wisdom. One of the best crystals for anxiety, it has nourishing energy perfect for assisting those with deep emotional wounds. Lepidolite also assists you in releasing old paradigms and psychological behaviors that no longer serve you.',
    chakra: 'Crown',
    zodiac: 'Libra',
    bestfor: 'Emotional Healing, Change, Anti-Anxiety',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/lepidolite-crystal-meaning',
  },
  {
    title: 'Lithium Quartz',
    description:
      'Lithium Quartz is a powerful but gentle heart chakra stone, the perfect companion to help you achieve emotional peace. It is a great teacher that allows you to understand the patterns and people you attract into your life, especially the relationships that end in heartache. If you find yourself repeating unhealthy cycles when it comes to friends, family or partners, Lithium Quartz can assist you in recognizing them and encourage you to make the necessary changes. On top of that, it also helps you release past attachments and unhealthy expectations.',
    chakra: 'All',
    zodiac: 'Aquarius',
    bestfor: 'Peace, Relationships, Change',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/lithium-quartz',
  },
  {
    title: 'Lodestone',
    description:
      'As a calming stone, Lodestone helps you relax more easily. It reduces negativity in your environment and eases the tension in your body. It enables you to think more clearly and set powerful and life-changing intentions. It also assists you in connecting with your higher self and activating your intuition. In addition, Lodestone is one of the greatest crystals for manifestation. It attunes you to what you want and what you need, propelling you towards high personal growth and deeper wisdom and insight.',
    chakra: 'Root',
    zodiac: 'Gemini, Virgo',
    bestfor: 'Relaxation, Intuition, Manifestation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/lodestone',
  },
  {
    title: 'Malachite',
    description:
      'Malachite represents new life and rebirth, as well as energy and growth. A stone of transformation, it assists you in welcoming much needed changes in your life. It also allows you to see the good in the people around you. On the flipside, it also enables you to discover the root cause for the toxicity in your life. Malachite reminds you that it’s never too late to turn over a new leaf. It renews your spiritual energy and fiery passions that you have forgotten, and connects you to the past while still remaining grounded in the present.',
    mexicantext:
      'Malachite is highly sought after for its deep, soul-stirring green. Its copper content gives it a unique banded pattern that makes this gemstone stand out from the rest! Look for the best Malachite from Mexico in Zacatecas.',
    australiantext:
      "Malachite from Australia is a deep green gemstone with a mesmerizing mottled pattern. Western Australia supplies some of the world's best specimens.",
    chakra: 'Heart',
    zodiac: 'Scorpio, Capricorn',
    bestfor: 'Rebirth, Self-Discovery, Passion',
    jevelry: 'https://consciousitems.com/collections/malachite',
    bracelets: 'https://consciousitems.com/collections/malachite-bracelet',
    rings: 'https://consciousitems.com/collections/malachite-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/malachite-stone',
    green: 'green',
    mexican: 'mexican',
    australian: 'australian',
  },
  {
    title: 'Meteorite',
    description:
      'Meteorite is believed to channel the energy of the Universe right into the palm of your hands. It can be used to balance and align the energetic fields of the body and expand consciousness beyond your physical boundaries. Meteorite promotes introspection and brings a more in-depth insight into existing problems or situations. It can help us realize the purpose of our existence on this planet and in life. On top of that, it teaches you to adapt to change more readily and encourages mental growth.',
    chakra: 'Root',
    zodiac: 'Sagittarius',
    bestfor: 'Consciousness, Introspection, Purpose',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/meteorite',
  },
  {
    title: 'Moldavite',
    description:
      'Often referred to as The Holy Grail Stone, Moldavite is the stone of ultimate transformation. This means it not only helps you make necessary changes in your own life, but it also has the power to transform your thoughts and ideas. The high vibration and intensity of this stone make it one that causes rapid change in your mind and spirit. Moldavite holds the key to widening your mind, helping you get rid of unhealthy patterns, outdated ideas, and constraints that hold you back from achieving your fullest purpose in life.',
    chakra: 'Heart',
    zodiac: 'Aquarius, Cancer, Capricorn, Gemini, Leo, Pisces, Sagittarius, Scorpio',
    bestfor: 'Transformation, Power, Purpose',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/moldavite-guide',
    green: 'green',
  },
  {
    title: 'Mookaite Jasper',
    description:
      'Mookaite Jasper is known for encouraging flexibility and creativity. Filled with positivity, a sense of grounding, and light, Mookaite Jasper helps you remain in the present moment. It encourages you to take life by its reins and enjoy the day-to-day events and activities in your life. On top of that, it is a great crystal for facilitating the process of change and transition, allowing you to resist the urge to stay in the status quo. As long as there are aspects of your life that do not bring you joy, Mookaite Jasper can help you overcome them.',
    chakra: 'Solar plexus, root',
    zodiac: 'Scorpio, Virgo',
    bestfor: 'Flexibility, Light, Joy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/mookaite-jasper',
  },
  {
    title: 'Moonstone',
    description:
      'Moonstone exudes a vitality that allows you to feel re-energized. Associated with strength and calmness, it is known to enhance intuition and inspire success in all avenues of your life. Moonstone is often used to wash away negative energy and rebalance the room. It brings harmony into the space it is placed, and disperses any unwanted tension and stress. It can also be used to encourage creativity, free expression, and fertility. On top of that, it is said to be one of the greatest crystals for enhancing insight and vision.',
    indiantext:
      'Jharkhand and Tamil Nadu are the best places to find Indian Moonstone, with its silvery sheen and mysterious, iridescent glow. This beloved gem is said to enhance intuition and inner vision, making it ideal for those who enjoy foraying into the unknown.',
    australiantext:
      'The smooth, translucent quality of Moonstone has made it popular for centuries. You can find Australian Moonstone in shades of white, grey, and blue in several areas in Queensland.',
    srilankatext:
      "Who doesn't love basking in the mysterious light of Sri Lankan Moonstone? Its milky opalescence is the stuff of dreams, with a color range extending from blue to yellow, green, and grey. The North Western and Sabaragamuwa Provinces are your best bet for finding a specimen you won't be able to resist.",
    chakra: 'Crown, third eye, heart',
    zodiac: 'Gemini',
    bestfor: 'Vitality, Intuition, Fertility',
    jevelry: 'https://consciousitems.com/collections/moonstone',
    bracelets: 'https://consciousitems.com/collections/moonstone-bracelet',
    rings: 'https://consciousitems.com/collections/moonstone-ring',
    link: 'https://consciousitems.com/blogs/lifestyle/moonstone-crystal',
    indian: 'indian',
    australian: 'australian',
    srilanka: 'srilanka',
  },
  {
    title: 'Morganite',
    description:
      'Morganite is a stone of divine love. It is known to bring healing and promise to those who use it. It attunes you to the frequency of your heart and allows you to connect with it on a deeper level. Morganite also attracts love into your romantic relationships, by enhancing positive thoughts and harmonious communication. A symbol of innocence and health, Morganite stimulates the heart chakra and serves as a healer of emotional wounds. In addition, it raises your energy and increases the intensity of your passions.',
    text: "Morganite from Brazil is generally light pink. The gemstone's hardness—almost 8 on the Mohs Scale—makes it perfect for jewelry. Ouro Preto is ground zero for Morganite mining.",
    chakra: 'Heart',
    zodiac: 'Pisces, Taurus, Cancer',
    bestfor: 'Love, Harmony, Innocence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/lifestyle/morganite-stone',
    brazilian: 'brazilian',
  },
  {
    title: 'Moss Agate',
    description:
      "Moss Agate supports the healing of emotional wounds. Whether it's healing from heartbreak, seeking forgiveness, or finding love, a Moss Agate crystal can help. It can help you find inner peace when things seem too chaotic to face. It releases fear that causes emotional blocks and encourages you to apply mental concentration to the tasks at hand. Moss Agate also assists you in removing emotional distractions by channeling your energy towards a fun and creative goal. It reduces mood swings and brings a healthy self-esteem.",
    text: 'Moss Agate is highly prized in Sri Lanka for its unique patterns that often resemble mossy forests. Moss Agate mostly comes in shades of green and brown—but occasional specimens can be found with a red, black, or yellow tint.',
    chakra: 'Heart',
    zodiac: 'Virgo',
    bestfor: 'Emotional Healing, Concentration, Self-Esteem',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/moss-agate-meaning',
    green: 'green',
    srilanka: 'srilanka',
  },
  {
    title: 'Ocean Jasper',
    description:
      'A great stone for general happiness, Ocean Jasper encourages you to grab life with both hands and cling on like a whelk to a ship. Its energy resonates with love and joy so that you can always find a reason to smile. Ocean Jasper teaches that what goes around comes around. It unveils the cyclic nature of the universe and brings order from chaos. It can also cleanse you of past wrong-doings if you’re ready to forgive yourself. Its purifying energy encourages you to take responsibility for the past and take bold steps towards a future of your choice.',
    chakra: 'Heart, solar plexus',
    zodiac: 'Capricorn, Cancer, Pisces',
    bestfor: 'Happiness, Purification, Responsibility',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/ocean-jasper',
  },
  {
    title: 'Opalite',
    description:
      'Opalite is associated with youth and child-like wonder. It helps you see life with optimism and curiosity and helps you understand how to go with the flow. It casts out negativity with its warm and positive energy. Also, Opalite is also known to put heavy hearts at ease, especially from emotional burdens like depression and overwhelment. If you struggle with resentment and anger, Opalite will help you replace these feelings with compassion and kindness. It also brings a more positive outlook on life that you can take into any situation.',
    chakra: 'Third eye',
    zodiac: 'Cancer',
    bestfor: 'Youth, Optimism, Positivity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/opalite-1',
  },
  {
    title: 'Orange Calcite',
    description:
      'Orange Calcite connects you to Divine Masculine Energy. It activates the active and action-prone principle of your energy. It helps you break bad habits and low vibration cycles, especially those that are tied to your past life and karmic processes. Orange Calcite attunes you to a wealth and abundance mindset, aligning you with the divine prosperity that you have access to. In addition, it encourages you to embrace your creative and spirited nature. Through working with Orange Calcite, you will be more attuned to joy.',
    chakra: 'Solar plexus',
    zodiac: 'Cancer, Leo',
    bestfor: 'Action, Abundance, Creativity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/orange-calcite-meaning',
    orange: 'orange',
  },
  {
    title: 'Orgonite',
    description:
      'Orgonite crystal has a calming and soothing effect on people. It promotes positive emotions like peace, joy, and serenity while curbing stress and negative thoughts. Orgonite is also known for supporting spiritual growth. By curbing negative energy around you and calming your overactive mind, it deepens your meditative state and allows you to focus on letting your emotions flow for your highest good. It is also said to aid in enhancing restful sleep and facilitating dream recall and dream interpretation.',
    chakra: 'All',
    zodiac: 'All',
    bestfor: 'Positivity, Spirituality, Meditation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/what-is-orgonite-stone',
  },
  {
    title: 'Mother of Pearl',
    description:
      'Mother of Pearl activates your psychic abilities and clairvoyance, allowing you to see past what is right in front of you and enabling you to see into the spiritual realm. With this ability, you are able to receive important guidance and strength that you need in order to live a fruitful and meaningful life on the physical plane. Additionally, the pearl instills in you a sense of confidence and high self-esteem. Where you do not typically have personal power and courage, the pearl will step in and cultivate a sense of self-confidence in you.',
    chakra: 'Crown, third eye',
    zodiac: 'Pisces',
    bestfor: 'Psychic Abilities, Guidance, Confidence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/what-is-mother-of-pearl',
    grey: 'grey',
  },
  {
    title: 'Peridot',
    description:
      'Peridot attunes you to prosperity and success. It allows you to experience abundance in all aspects of your life - not just in terms of financial independence, but also in the love and blessings you receive from the Universe. In addition, Peridot is a great crystal for shielding you from negativity and releasing old habits and patterns that no longer serve you. It allows you to move forward with confidence and ease. Peridot also balances and upgrades your energy, and its beauty and energetic properties will give you a boost of self-esteem.',
    australiantext:
      'Peridot is a sparkling yellow-green gemstone said to bring joy and success. Peridot from Australia comes mainly from a few select areas of North East Queensland, particularly in Cheviot Hills and Chudleigh Park.',
    chakra: 'Heart',
    zodiac: 'Leo',
    bestfor: 'Abundance, Confidence, Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/peridot',
    green: 'green',
    australian: 'australian',
  },
  {
    title: 'Petrified Wood',
    description:
      'Petrified Wood connects you to the spirit and ancient energies of Mother Gaia. These nurturing earth energies promote balance in your energy field. It also allows you to boost your manifestation process and encourages you to live life to your highest potential. Balancing and stabilizing, it assists you in activating your inner light while grounding you in the present. In addition, Petrified Wood is a great supporter to your healing and recovery journey, as it connects you to the healing and nurturing energy of Mother Gaia.',
    chakra: 'Root',
    zodiac: 'Leo, Virgo',
    bestfor: 'Balance, Potential, Grounding',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/petrified-wood',
    brown: 'brown',
  },
  {
    title: 'Phantom Quartz',
    description:
      'Phantom Quartz is renowned for its ability to bring balance to your body. As a crown chakra crystal, it regulates the flow of energy from the root to the crown. In doing so, it naturally brings harmony to the subtle energies in your aura. It is said to stabilize the yin and yang, making you more aware of your partner’s needs in a relationship and balancing both sides of your personality and character. It also infuses you with a sense of pure love and joy by tapping into the Universe’s unconditional love for you.',
    chakra: 'Crown',
    zodiac: 'All',
    bestfor: 'Balance, Stability, Love',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/a-guide-to-phantom-quartz',
  },
  {
    title: 'Picture Jasper',
    description:
      'Picture Jasper is a grounding stone that is so deeply connected with the earth and ancient times that it is thought to help give you a glimpse into the distant past. Picture Jasper helps you connect with the earth on a deeper level, awakening your global consciousness and deepening your desire to protect the earth and her resources. When you’re feeling lost with no sense of direction, Picture Jasper is the compass you need to find your way. It gives you the space and clarity you need in order to decipher and decode the meaning of your life.',
    chakra: 'Root',
    zodiac: 'Leo, Capricorn',
    bestfor: 'Grounding, Consciousness, Direction',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/picture-jasper-meaning-ultimate-guide',
  },
  {
    title: 'Pink Opal',
    description:
      'Pink Opal allows you to free yourself from stress and worry. It eliminates tension in your body and releases anxious thoughts and feelings. It encourages you to not get caught up in drama or be overwhelmed with other people’s emotions, and to instead focus on your own needs and desires. It also aids in better and more restful sleep, due to its gentle and soothing nature. It prevents nightmares and intermittent sleep. In addition, Pink Opal enables you to find relief through deep and pure emotional healing.',
    chakra: 'Heart',
    zodiac: 'Gemini, Aquarius',
    bestfor: 'Release, Emotional Healing, Sleep',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/pink-opal',
    pink: 'pink',
  },
  {
    title: 'Pink Tourmaline',
    description:
      'Pink Tourmaline crystal is one of the best stones for relieving stress. It empowers you to interact on the physical plane from a higher spiritual perspective, and holds the power to attract the divine will into your life. The loving energy of your higher self and of your Divine Counterpart are naturally in tune with Pink Tourmaline. It fills your emotional body with positive energy and provides you with all the emotional support that you need. Moreover, it helps you find your way towards self-love, which is the root of all emotional wellbeing.',
    chakra: 'Heart',
    zodiac: 'Libra',
    bestfor: 'Spirituality, Positivity, Self-Love',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/pink-tourmaline-meaning',
    pink: 'pink',
  },
  {
    title: 'Purple Fluorite',
    description:
      'Purple Fluorite is a focus stone that brings mental clarity and attunes us to pure peace. It is a dream crystal. It facilitates dream recall and dream interpretation, allowing us to be receptive to messages from the Universe in our dreams. Purple Fluorite brings self confidence to our energy fields, allowing us to radiate strength and healing power. It is a powerful stone often used in gem elixirs that are specifically for clearing negative energy. In addition, it protects us from any harmful energy in our environment.',
    chakra: 'Crown',
    zodiac: 'Pisces',
    bestfor: 'Focus, Clarity, Confidence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/purple-fluorite',
    purple: 'purple',
  },
  {
    title: 'Pyrite',
    description:
      'Pyrite is associated with purity and the power of creativity. It has a strong masculine energy that shields its wearers from emotional attacks and negative energies. It cuts through negative vibrations around you and cleanses toxic thoughts. This stone allows you to see the truth in every situation and live authentically. Pyrite is also a powerful ally for other healing crystals, empowering you to be on top of the spiritual and physical world. In addition, it attunes you to prosperity consciousness, thus attracting wealth and abundance into your life.',
    chakra: 'Root',
    zodiac: 'Leo',
    bestfor: 'Creativity, Shielding, Prosperity',
    jevelry: 'https://consciousitems.com/collections/pyrite',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/pyrite-crystal-meaning',
  },
  {
    title: 'Rainbow Obsidian',
    description:
      'Rainbow obsidian is a supportive and healing stone. Its healing and nurturing properties allow you to recover from a broken heart with ease. Whether you’re grieving the loss of a loved one or trying to cope without a beloved pet, Rainbow Obsidian can help you move through the darkest of times. In addition, it protects you from negativity by supporting you in snapping out of your unhealthy thoughts and attuning yourself to positive energy all around you. It also brings a greater sense of grounding and confidence.',
    chakra: 'Root',
    zodiac: 'Libra, Cancer',
    bestfor: 'Support, Positivity, Grounding',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/rainbow-obsidian',
    black: 'black',
  },
  {
    title: 'Red Agate',
    description:
      'Red Agate guards against negative energies while instilling you with self-confidence and positive vibes. Known as the "warrior\'s stone," it is said to light the fire in your heart and motivate you to pursue what you want. It is a great support stone for artists and writers as it helps boost creativity. Red Agate’s energy can have a very positive effect on cooks, chefs, and bakers, as it protects them from accidents in the kitchen. It also provides educators and recreational workers with emotional endurance and patience.',
    chakra: 'Root',
    zodiac: 'Capricorn, Pisces, Taurus, Scorpio',
    bestfor: 'Protection, Motivation, Endurance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/red-agate',
    red: 'red',
  },
  {
    title: 'Red Coral',
    description:
      'Red Coral promotes success in life and business, helps give confidence to those in leadership roles, and even promotes luck in sporting events. Red Coral is also a stone of wisdom, helping you make better decisions with rational thinking. Red Coral also increases maturity and eliminates foolish or non-serving behaviors. Its balancing and foundational energy allows you to tap into your deepest passions. It keeps us energized and balanced, so we experience a sense of belonging, increased self-esteem, and integrity.',
    chakra: 'Root',
    zodiac: 'Aries',
    bestfor: 'Confidence, Rationality, Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/red-coral-healing-properties',
    red: 'red',
  },
  {
    title: 'Red Jasper',
    description:
      'Red Jasper’s peaceful and relaxing frequency helps ground your energy and bring you back to your physical body and the present moment. It is especially beneficial if you are an over-thinker and have a hard time seeing things clearly due to the overwhelming and uncontrollable flow of your thoughts. In addition, Red Jasper is a crystal of courage. Not only does it support you in coping with unhealthy relationships, but it also provides you with the strength to overcome these toxic situations with self-worth and self-confidence.',
    chakra: 'Root',
    zodiac: 'Cancer, Capricorn, Aries, Scorpio',
    bestfor: 'Grounding, Courage, Strength',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/red-jasper',
    red: 'red',
  },
  {
    title: 'Rhodochrosite',
    description:
      'Rhodochrosite has a naturally nurturing energy. It can heal past memories that involve shame, physical or emotional abuse, or other traumatic experiences. It also helps you retrieve memories from other lifetimes that may hinder you in this one. Rhodochrosite can give you the strength to confront and healthily integrate memories that lie dormant in your consciousness. It also attunes you to the highest levels of self-love and encourages you to start genuinely loving and accepting yourself for all that you are and all that you bring to the world.',
    chakra: 'Heart',
    zodiac: 'Leo, Scorpio',
    bestfor: 'Nurturing, Memories, Self-Acceptance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/rhodochrosite',
    pink: 'pink',
  },
  {
    title: 'Rhodonite',
    description:
      "Rhodonite is associated with deep love and compassion. Rhodonite is an excellent stone for forgiveness. It supports you in managing painful memories and moving on from unhealthy or abusive situations. Whether you're hoping to release feelings of resentment and abandonment or practice self-compassion to find peace of mind, turn to Rhodonite crystals for comfort. It also bridges the gap between you and your loved ones, by instilling in you a sense of harmony and gentle but effective communication styles.",
    australiantext:
      'Broken Hill, a town in NSW, is the best place to find Australian Rhodonite, a pink-red gemstone famous for its understated beauty. Believed by some to attract love, this gemstone is worth the effort to find.',
    chakra: 'Heart',
    zodiac: 'Taurus',
    bestfor: 'Compassion, Forgiveness, Harmony',
    jevelry: 'https://consciousitems.com/collections/rhodonite',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/rhodonite-meaning-and-healing-properties',
    pink: 'pink',
    australian: 'australian',
  },
  {
    title: 'Rhyolite',
    description:
      'Rhyolite allows you to move through changes with ease, whether that means moving to a new neighborhood or revamping your daily routine. It supports you by releasing feelings of resistance, inertia, and self-doubt. It is an excellent stone for coping with challenging times. It allows you to tap into your inner strength, develop grit, and go deeper in your meditation practice to help you move through your life with ease. Rhyolite also instills in you a sense of true and pure love and acceptance for yourself.',
    chakra: 'Heart',
    zodiac: 'Sagittarius, Aquarius, Gemini',
    bestfor: 'Change, Inner Strength, Self-Acceptance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/rhyolite-meaning',
  },
  {
    title: 'Rose Quartz',
    description:
      'Rose Quartz is known as the unconditional love crystal. It represents universal, agape love for oneself, the universe, all others, and all living things. Rose Quartz emanates femininity, openness, elevation, and deepening of love. It opens your heart to receiving love, giving love, and truly experiencing what it means to be joyful. It is also capable of restoring harmony where there is discord, even if that discord is found within oneself. In a relationship, it can help deepen eros love and build an elevated level of communication.',
    mexicantext:
      'These gems range in hue from pale blush to deep rose. Its light-filled beauty makes it the perfect choice for a romantic gift. Find these sparklers in Durango and El Bajio, where they are found in abundance!',
    braziliantext:
      'Another Quartz variety, Rose Quartz is popular for its pink hue that symbolizes love and tenderness. Brazil has several large deposits of this gemstone in Rio Grande do Sul and Bahia.',
    srilankatext:
      'Sri Lankan Rose Quartz is a pink variety of quartz, usually with a milky or transparent hue. Its beauty can be enjoyed throughout the country, with some exceptional specimens coming from the Central and Sabaragamuwa Provinces.',
    chakra: 'Heart',
    zodiac: 'Libra, Taurus',
    bestfor: 'Love, Joy, Harmony',
    jevelry: 'https://consciousitems.com/collections/rose-quartz',
    bracelets: 'https://consciousitems.com/collections/rose-quartz-bracelet',
    rings: 'https://consciousitems.com/collections/rose-quartz-ring',
    link: 'https://consciousitems.com/blogs/crystal-guides/rose-quartz-meaning-healing-ultimate-guide',
    pink: 'pink',
    srilanka: 'srilanka',
    mexican: 'mexican',
    brazilian: 'brazilian',
  },
  {
    title: 'Rutilated Quartz',
    description:
      'Rutilated Quartz is a spiritual illuminator. It balances all your chakras and connects you to divine inspiration, thus stimulating your spiritual creativity and amplifying your thoughts. It is also said to connect you to your past, present, and future. In addition, Silver Rutile enhances your mental energy; Green Rutile protects your mind; Black Rutile enhances your intuition; Blue Rutile balances your energy, which promotes relaxation; and Golden Rutile links you to your divine willpower to get things done efficiently and effectively.',
    braziliantext:
      "Found only in Bahia, Rutilated Quartz from Brazil is unique for its golden-bronze needles embedded within the gem—resulting in a play of light and color that is truly mesmerizing. Don't get lost in its beauty!",
    chakra: 'All',
    zodiac: 'All',
    bestfor: 'Illumination, Inspiration, Amplification',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/rutilated-quartz-meaning',
    brown: 'brown',
    brazilian: 'brazilian',
  },
  {
    title: 'Sapphire',
    description:
      'Sapphire comes in many different hues. Blue Sapphire connects to water energy, bringing a deep sense of serenity and peace at all times, through obstacles and challenges. It also attunes your thoughts and ideas to divine wisdom and facilitates intellectual processes. Pink Sapphire increases deep emotional awareness and healing, and Yellow Sapphire connects you with the powers of the sun. It brings clarity to the direction of your life. Green Sapphire clears negative energies from your heart, and Star Sapphire sharpens your inner vision.',
    indiantext:
      'Blue Sapphire (Neelam) and Yellow Sapphire (Pukhraj) are the most popular types of Sapphire in India. Both are believed to bring peace and tranquility to the wearer. Jammu and Kashmir, Odisha, and Tamil Nadu are the most common sources of Sapphire in India.',
    australiantext:
      "Blue Sapphires are the most common type in Australia, though you won't find it hard to spot yellow or green specimens. The majority of these gems come from the two main sites mentioned earlier: Northern New South Wales and Central Queensland.",
    srilankatext:
      "Sri Lanka's signature gemstone! The island's Sapphire is known for its bold, velvety cornflower blue color as well as the size and clarity of the gems. Find the perfect Sri Lankan Sapphire in the country's fields in the Western, Sabaragamuwa, North Central, and Uva Provinces.",
    chakra: 'Third eye, heart, solar plexus',
    zodiac: 'Virgo',
    bestfor: 'Wisdom, Awareness, Vision',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/sapphire',
    blue: 'blue',
    indian: 'indian',
    australian: 'australian',
    srilanka: 'srilanka',
  },
  {
    title: 'Septarian',
    description:
      "Septarian harmonizes the energy in your relationships. It brings comfort and peace to tensions in relationships. On an emotional level, it brings comfort and support to your well-being. As a grounding stone, its calming energies aid in emotional healing. Septarian is known to be a conduit of the Earth's grounding and healing energy. It is said to allow you to cultivate better tolerance of difficult issues and circumstances in your life, and raises your spiritual awareness while grounding you in the present moment simultaneously.",
    chakra: 'Root, solar plexus',
    zodiac: 'Taurus, Sagittarius',
    bestfor: 'Harmony, Comfort, Grounding',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Serpentine',
    description:
      'Just as serpents represent immortality, transformation, knowledge and health, so do Serpentine crystals. They enhance your spiritual and psychic connection to the earth, and their deep-green hue puts you in touch with mother nature. Serpentine stone activates all the chakras. It welcomes in energy from the ground, rooting you to the earth and infusing your chakras with freshness. Serpentine is one of the best crystals for facilitating kundalini awakening, which is why it is so powerful when used in meditation.',
    text: 'For those who like a bit of spunk in their gemstone collection, Serpentine is the way to go. This stone has a striking green and black hue that brings out the wild side in us all! The best Serpentine can be found in Tehuitzingo.',
    chakra: 'Heart',
    zodiac: 'Gemini',
    bestfor: 'Transformation, Nature, Awakening',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/use-serpentine-stone-to-awaken-kundalini-energy',
    green: 'green',
    mexican: 'mexican',
  },
  {
    title: 'Shungite',
    description:
      'Shungite is an outstanding grounding stone, used to calm the mind and create stability. Its powerful vibration makes it a powerful neutralizing stone that helps harmonize your masculine and feminine sides. It assists you in staying grounded and sensible, while still allowing you to dream big. As a stone of action and pragmatism, it is the perfect companion to enhance your focus and determination, especially through periods of change and growth. It is also useful for shedding patterns and old beliefs that no longer align with who you wish to become.',
    chakra: 'Root',
    zodiac: 'Scorpio, Capricorn, Cancer',
    bestfor: 'Grounding, Balance, Action',
    jevelry: 'https://consciousitems.com/collections/shungite',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/shungite',
    black: 'black',
  },
  {
    title: 'Smoky Quartz',
    description:
      'Smoky Quartz represents balance and centering. It is a potent grounding crystal that reminds you of your connection to the earth. It keeps you centered and cuts through your illusions. Smoky Quartz also assists in detoxification, by absorbing negative energy and channeling it back to the earth, leaving only positive frequencies in your aura. Not only does a Smoky Quartz crystal work to create an energetic shield around you, but it also clears negativity from your energy field on a regular basis.',
    text: "For those looking for a subtle, smoky hue that fits perfectly into any look, Brazil has plenty of Smoky Quartz. It's especially abundant in Bahia and Minas Gerais.",
    chakra: 'Root',
    zodiac: 'Scorpio, Sagittarius, Capricorn',
    bestfor: 'Balance, Grounding, Positivity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/smoky-quartz-meaning',
    brown: 'brown',
    brazilian: 'brazilian',
  },
  {
    title: 'Snowflake Obsidian',
    description:
      'Snowflake Obsidian stone is a purifying stone that can help you attain peace and serenity. It detoxifies the emotional body, declutters the mind from negative energy, and lets your emotions flow freely. Meditating with the Snowflake Obsidian stone will allow you to expand your consciousness and discover more about yourself. Known as the stone of purity, it can also bring balance to your mind, body, and spirit. Overall, it empowers your soul and enables you to carve a space for yourself that is separate from the chaos of the world.',
    chakra: 'Root',
    zodiac: 'Capricorn, Virgo',
    bestfor: 'Purification, Discovery, Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/snowflake-obsidian-meaning',
    black: 'black',
    grey: 'grey',
  },
  {
    title: 'Sodalite',
    description:
      'Sodalite is both calming and empowering at the same time. It enhances communication, improves emotional wellbeing and boosts mental clarity. It allows you to convey your emotional, spiritual and mental processes and feelings with clarity and ease, allowing you to be understood by people on the other end of the communication. It also removes energy blockages from your spiritual body, especially those that hold you back from achieving deep inner peace. It also brings you wisdom and insight from the Universe.',
    australiantext:
      "If you're seeking something a little less vibrant and more subdued, then Sodalite is the gemstone for you. It has a blue-grey hue and brings mental clarity, intuition, and inner truth. You can find Australian Sodalite easily in Queensland, Tasmania, South Australia, and New South Wales.",
    chakra: 'Third eye',
    zodiac: 'Pisces, Sagittarius',
    bestfor: 'Clarity, Communication, Wisdom',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/sodalite',
    blue: 'blue',
    australian: 'australian',
  },
  {
    title: 'Spirit Quartz',
    description:
      'Spirit Quartz aids you in developing patience and tolerance for the events in your life. It also allows you to clearly recognize the aspects of your life that are no longer serving you, so that you can calmly and peacefully let them go. Known as a Master Healer, it is a protective stone that rids your emotional body of all negative attachments. It is also a good crystal for astral travel, allowing your soul to leave your body in your dream state and come back to the present moment with newfound insight and wisdom.',
    chakra: 'Crown',
    zodiac: 'Virgo, Libra, Capricorn, Aquarius, Pisces',
    bestfor: 'Release, Protection, Astral Travel',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Strawberry Quartz',
    description:
      'Strawberry Quartz is deeply connected to the Universe’s unconditional love, thus allowing deep and pure love to flow through your entire emotional body. It transcends the physical world to reach higher energies of love that are then poured into your life and washed over you, so that you can discover the true meaning that binds us all. Strawberry Quartz also enables you to take a step inwards towards something even deeper than what your senses can absorb. Overall, it is a great crystal to attain peace of mind through the beauty of love.',
    text: 'Dainty and delicate, Brazilian Strawberry Quartz is a surefire showstopper. Thankfully, the country has a rich deposit of this gemstone in several regions, includingBahia, Minas Gerais, and Tocantins.',
    chakra: 'Heart',
    zodiac: 'Libra',
    bestfor: 'Love, Self-Discovery, Peace',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/strawberry-quartz',
    pink: 'pink',
    brazilian: 'brazilian',
  },
  {
    title: 'Sugilite',
    description:
      'Sugilite allows you to cultivate stronger bonds with the people in your life. It encourages you to re-evaluate the relationships in your life and determine which ones are no longer serving you. Following that, it gives you the courage and strength to move on from those relationships with ease. Sugilite also supports your spiritual growth by building a bridge between your physical reality and the spiritual realms. In doing so, you will also be able to connect to your spirit guides and guardian angels more easily and be able to call upon them whenever you need help.',
    chakra: 'Crown',
    zodiac: 'Pisces, Virgo',
    bestfor: 'Relationships, Growth, Spirituality',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/sugilite',
    purple: 'purple',
  },
  {
    title: 'Sunstone',
    description:
      "Sunstone exudes positive energy and brings good luck and fortune to all your endeavors. It allows you to cope better with the challenges and obstacles in your life, and overcome them with motivation and drive. It also instills a sense of zest for life in you, so that you can see the same situations with a new and more optimistic perspective. Sunstone is said to be a great teacher of self-worth and self-confidence. It encourages you to go after the things that light you up, so you can create the life you've always wanted.",
    australiantext:
      'Like a burst of sunshine, Sunstone is typically a sparkling tabby-orange hue with flecks of orange-red. Watch out for "Rainbow Lattice" Sunstones, which is the most famous type of Australian Sunstone—grab yours from Harts Range in the Northern Territory!',
    chakra: 'Sacral',
    zodiac: 'Libra, Leo',
    bestfor: 'Positivity, Zest, Confidence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/sunstone',
    orange: 'orange',
    australian: 'australian',
  },
  {
    title: 'Tourmaline',
    description:
      'Tourmaline comes in varying shades. Black Tourmaline is a grounding and centering stone that gives you a sense of certainty and confidence, while Pink Tourmaline cultivates a deep emotional connection between you and your loved ones. Purple Tourmaline enhances mental calmness and serenity, and Green Tourmaline channels health, vitality and life to every fiber of your being, so that you are infused with courage and strength. Blue Tourmaline supports you in dealing with challenges and obstacles in your life, bringing you peace and tranquility.',
    braziliantext:
      "The bulk of the global supply of Tourmaline is mined in Brazil, and it is the country's most prolific gemstone. Tourmaline comes in all sorts of colors, from deep red to lime green—many are sourced from the richly diverse deposits in Minas Gerais.",
    australiantext:
      "Abundant in hues of pink, green and blue, Tourmaline from Australia is truly breathtaking. It's said to bring balance and self-confidence—something we all need! Luckily, Australia is awash with Tourmaline deposits. We suggest starting your hunt in New South Wales or Western Australia.",
    srilankatext:
      "Yellow-green to emerald-green are the most common hues of Tourmaline from Sri Lanka. The island also contains darker Tourmalines, from brownish-red to near black. Mined extensively in the Sabaragamuwa Province, Tourmaline is perhaps the most abundant of Sri Lanka's gemstones.",
    chakra: 'Root, heart, crown, third eye, throat',
    zodiac: 'Libra, Capricorn, Scorpio',
    bestfor: 'Grounding, Vitality, Strength',
    jevelry: 'https://consciousitems.com/collections/tourmaline',
    bracelets: 'https://consciousitems.com/collections/tourmaline-bracelet',
    rings: 'https://consciousitems.com/collections/tourmaline-ring',
    link: 'https://consciousitems.com/blogs/lifestyle/tourmaline-stone',
    black: 'black',
    brazilian: 'brazilian',
    australian: 'australian',
    srilanka: 'srilanka',
  },
  {
    title: 'Tree Agate',
    description:
      "Tree Agate connects you to feng shui, allowing you to harmonize the energies of the Universe for your highest good. It also propels you in your personal development journeys, encouraging you to challenge ourselves and reach for new heights. Through life's ups and downs, Tree Agate brings a quiet energy that dispels negative energy and enhances your inner stability. This encourages you to cope with life's challenges in a more harmonious and mature manner. In addition, it propels you towards spiritual growth.",
    chakra: 'Heart',
    zodiac: 'Virgo, Taurus, Gemini',
    bestfor: 'Personal Growth, Stability, Calmness',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Turquoise',
    description:
      'Turquoise supports the revitalization of all your chakras. It clears blockages and stagnant energy from your energy fields and replaces them with healing and soothing energy. It also assists you in cultivating a more hopeful and optimistic outlook in life, which is useful in overcoming difficult situations in your daily routine. In addition, its positive vibrations shield you from negativity in your surroundings and protect you from potential mishaps. Turquoise is also a useful crystal for harmonizing your energy and recharging your emotional body.',
    mexicantext:
      'With deep, watery hues that invite pensive reflection, Turquoise from Mexico is prized for its serene beauty. A favorite among locals, this gemstone has been used for centuries to create jewelry, tools, and sculptures. Find these exquisite gems in Campitos.',
    australiantext:
      'Australia has some of the best quality Turquoise in the world. It has a unique matrix-like pattern, and its powdery green color brings to mind still ponds and serene nature. Australian Turquoise is quite plentiful—New South Wales, Queensland, South Australia, Western Australia, and Tasmania all have rich Turquoise deposits.',
    chakra: 'Throat',
    zodiac: 'Sagittarius',
    bestfor: 'Revitalization, Optimism, Positivity',
    jevelry: 'https://consciousitems.com/collections/turquoise-1',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/turquoise',
    blue: 'blue',
    green: 'green',
    mexican: 'mexican',
    australian: 'australian',
  },
  {
    title: 'Yellow Calcite',
    description:
      'Yellow Calcite increases memory and self worth. It assists you in having a better retention of key concepts and information. It also builds your self confidence, infusing in you the belief that you are whole and perfect, just the way you are. In addition, Yellow Calcite is a great eliminator of accumulated self doubt, overall enhancing energy levels. It allows you to tap into your own personal motivation and personal power. Overall, it is a powerful energy cleanser that you can use to regain balance and harmony in your energy fields.',
    chakra: 'Solar plexus',
    zodiac: 'Cancer, Leo, Pisces',
    bestfor: 'Memory, Self-Confidence, Willpower',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/yellow-calcite',
    yellow: 'yellow',
  },
  {
    title: 'Chevron Amethyst',
    description:
      'Chevron Amethyst, the combination of White Quartz and Amethyst, forms a beautiful V-shaped white pattern on a deep sea of purple. Known for its abilities of calming and soothing the mind, Chevron Amethyst strengthens the qualities of Quartz while elevating the qualities of Amethyst. This powerful combination allows you to access divine wisdom and guidance from the Universe. It also deepens your meditative state, allowing you to receive clarity and insight from your meditation and take inspiration from the higher spiritual realms.',
    chakra: 'Third eye, crown',
    zodiac: 'Pisces',
    bestfor: 'Calmness, Wisdom, Clarity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/chevron-amethyst',
    purple: 'purple',
  },
  {
    title: 'Chiastolite',
    description:
      'Chiastolite is a grounding and centering stone that brings you back to the healing and nurturing energies of Mother Earth. Where you are lacking strength and motivation to carry on in your tasks or in pursuit of your dreams, Chiastolite brings a strong sense of willpower that reminds you to never give up hope. In addition, it protects you against negative energies that have been infused into your environment. Instead of absorbing negative energy like other grounding stones do, Chiastolite deflects the negative energy away from your environment permanently.',
    chakra: 'Root, sacral',
    zodiac: 'Capricorn, Libra',
    bestfor: 'Grounding, Strength, Willpower',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Chrysanthemum Stone',
    description:
      'Chrysanthemum Stone is a powerful healing crystal, partially due to it being the combination of many individually powerful minerals - Calcite, Feldspar, Celestite and Andalusite. Grounding and stabilizing, this crystal will return you back to the stability of the Earth. Therefore, it is one of the best crystals to journey with you on the path towards change and transition. In addition, it is said to bring luck and opportunity to your doorstep, allowing you to see synchronicities and new beginnings where you did not before. It is also a stone of peace and happiness.',
    chakra: 'Root, crown',
    zodiac: 'Taurus, Aquarius',
    bestfor: 'Stability, Change, Peace',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Chrysoberyl',
    description:
      'Chrysoberyl is one of the best crystals for discipline. Not only does it allow you to stick to the path that you set your mind to, thus achieving your goals in a quicker period of time, but it also enables you to put aside distractions and other things that are holding you back from your dreams. It is also a great stone to enhance focus and concentration, which makes it an excellent companion for you whenever you are studying or working. In addition, Chrysoberyl is a stone of self-control, enabling you to think far ahead and plan for the future with discipline.',
    srilankatext:
      'Disguised as water-worn and frosted pebbles, Chrysoberyl from Sri Lanka is found in alluvial gravels in the North Central and Sabaragamuwa Provinces. The most common colors are golden-yellow, olive green, and brownish-yellow.',
    australiantext:
      "Sporting an intense neon yellow-green color, Chrysoberyl from Australia is most famous for its higher-than-average refractive index, which gives it a vibrancy that gems from other countries just can't match. The gemstone can be found throughout the country, the most prominent being Harts Range in the Northern Territory.",
    chakra: 'Solar plexus, crown',
    zodiac: 'Leo',
    bestfor: 'Discipline, Focus, Self-Control',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    srilanka: 'srilanka',
    australian: 'australian',
  },
  {
    title: 'Cinnabar',
    description:
      'Cinnabar is one of the best crystals most commonly used for spiritual transformation and change. If you are going through a period in your life where you wish to shed the negativity and toxicity from your environment, or if you are experiencing change and transition in your spiritual journey, Cinnabar is a great companion for you. Not only does it replace negative energy around you with light and love, but it also infuses in you a deep sense of compassion and confidence to help those around you with their troubles.',
    text: 'White with flecks of bright red or purple, Mexican Cinnabar is a stunning specimen. It has been used for centuries in jewelry and decorative objects. Get the best one for you in San Luis Potosi!',
    chakra: 'Root, sacral',
    zodiac: 'Leo',
    bestfor: 'Transformation, Light, Confidence',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    red: 'red',
    mexican: 'mexican',
  },
  {
    title: 'Clear Calcite',
    description:
      'Clear Calcite, also known as Iceland Spar or Optical Calcite, is one of the best crystals for clarity and direction. It deepens your meditative state, allowing you to receive messages of divine wisdom and guidance that will propel you on your spiritual journey. Not only will it bring you the answers and solutions that you need in order to succeed in your physical reality, but it will also guide you towards your greatest dreams. If you are looking for rejuvenation or a fresh state, Clear Calcite is the crystal for you.',
    chakra: 'Crown, third eye',
    zodiac: 'Cancer',
    bestfor: 'Clarity, Guidance, Rejuvenation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/clear-calcite',
    clear: 'clear',
  },
  {
    title: 'Cobalto Calcite',
    description:
      'Cobalto Calcite, also known as Aphrodite Stone, is a form of Calcite that has inclusions of Cobalt in it. A stone of unconditional love, it brings kindness and compassion to your heart. It allows you to open your heart to receive love and trust in all your healthy relationships, and enables you to forgive those who have hurt you in the past. Only in doing so will you be able to move forward with ease. Therefore, Cobalto Calcite is one of the best crystals for bringing about emotional healing and supporting you in your spiritual journey.',
    chakra: 'Heart',
    zodiac: 'Cancer, Libra',
    bestfor: 'Love, Compassion, Forgiveness',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Covellite',
    description:
      'Covellite bridges the spiritual realm and the physical dimension to bring you the highest spiritual awakening. Covellite teaches your mind to be still and calm, so that it can receive all the divine wisdom and guidance from the Universe. In addition, it promotes astral travel that will allow you to gain insight from other realms and use them as important information and insight that can propel you on your journey on Earth. Covellite also supports bringing miracles into your life by turning your manifestations into reality in a short amount of time.',
    chakra: 'Crown, third eye',
    zodiac: 'Sagittarius',
    bestfor: 'Spirituality, Insight, Manifestation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Crazy Lace Agate',
    description:
      'Crazy Lace Agate brings a circular flow of energy to your physical and emotional body. It allows you to overcome your negative thoughts and unhealthy patterns that have been holding you back from your greatest potential, such as sadness, depression, and anger. It replaces those thoughts with uplifting and positive emotions that allow you to go through life with renewed self-esteem and self-confidence. In addition, Crazy Lace Agate reminds you of the importance of laughter in appreciating true wonder, beauty and miracle of life.',
    chakra: 'Third eye, crown',
    zodiac: 'Gemini',
    bestfor: 'Positivity, Self-Esteem, Beauty',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Creedite',
    description:
      'Creedite is an extremely powerful stone that allows you to bring the spiritual realm’s guidance and wisdom into your manifestation process. It raises your vibrations so that you are in constant alignment with the Universe’s light-filled vibrations. In doing so, it enables you to be on the right level to receive intuitive wisdom from the Universe and even channel messages from the Universe to your physical reality. In addition, Creedite supports healthy and gentle communication with the people around you, encouraging you to build strong relationships.',
    chakra: 'Third eye, crown, throat',
    zodiac: 'Virgo',
    bestfor: 'Guidance, Intuition, Communication',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Crocoite',
    description:
      'Crocoite awakens you to spiritual consciousness that goes beyond your physical dimension and reality. It allows you to experience the fields that exist beyond your level of comprehension and  in doing so, discover all that the Universe has to offer. Crocoite is a great crystal for reconnecting with your creative side. It supports your awareness of inspiration from the endless possibilities of the Universe and encourages you to use this insight and divine energy flow in order to propel you on your path towards your greatest dreams.',
    chakra: 'Sacral',
    zodiac: 'Aries',
    bestfor: 'Consciousness, Creativity, Flow',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    red: 'red',
  },
  {
    title: 'Cuprite',
    description:
      'Cuprite is a crystal that allows you to tap on your willpower and personal strength in order to strengthen your resolve towards achieving all that your heart desires. Where you are lacking hope and motivation or where you have given up, Cuprite’s energy will ground you in the reasons you wish to manifest those desires and enable you to move forward with strength. In addition, it curbs any irrational doubt and fears that you may have, thus allowing you to step forward in your true potential of vitality and rejuvenation.',
    chakra: 'Root, sacral',
    zodiac: 'Aquarius',
    bestfor: 'Willpower, Strength, Motivation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    red: 'red',
  },
  {
    title: 'Danburite',
    description:
      'Danburite’s pure and light-filled vibrations allow you to activate your awareness of higher realms and spiritual consciousness. In doing so, you will be able to receive messages and intuitive wisdom and guidance from the Universe. In addition, Danburite is an important crystal to have by your side when you are going through periods of challenge, adversity, or grief, as it will release negative emotions and reconnect you back to your divine self. Through Danburite’s stability, you will also experience true spiritual and emotional healing.',
    text: "If you're drawn to Danburite's limpid clarity, you'll have a ball seeking them out in Mexico! San Luis Potosi is home to some of the most breathtaking Danburite deposits in Mexico. Its crystalline form and delicate tones make it a popular stone for pendants, earrings, and rings.",
    chakra: 'Heart, crown',
    zodiac: 'Leo',
    bestfor: 'Consciousness, Grief, Stability',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    mexican: 'mexican',
  },
  {
    title: 'Dendritic Agate',
    description:
      'Dendritic Agate is a crystal that brings abundance to all aspects of your mind, body and soul. Known as the stone of plenitude, it creates a holistically peaceful environment that allows you to truly bask in the beauty and wonder of the Earth’s glory. In addition, Dendritic Agate is an excellent crystal for discovering new insights about yourself, your deepest thoughts and feelings, and the things in your life that are no longer serving you. It will also bring stability and security to your energy field, which gives you courage and strength.',
    chakra: 'Root, heart',
    zodiac: 'Gemini',
    bestfor: 'Abundance, Nature, Stability',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Diamond',
    description:
      'Diamond is a universally known symbol of purity and love. A common crystal to give your partner to symbolize everlasting love, it is one of the best crystals for fidelity. Not only will it allow you to stay loyal and faithful to your partner, but it will also enable you to act in dedicated and devoted ways in your relationship. Therefore, it builds a strong and healthy relationship. In addition, Diamond enhances your creative spirit and imagination, encouraging you to find new ways of looking at the same situation and allowing the inner child in you to shine through.',
    indiantext:
      "India used to be the world's biggest producer of diamonds and was an important trading center for these precious stones. Though its production has dipped in recent years, India is still known for its diamond cutting and trading, particularly in Panna, where most Indian diamonds are sourced.",
    australiantext:
      "We all know what Australian Diamond brings to the table. You'll find these sparkly gems in the Argyle mine in Western Australia, which is one of the world's largest suppliers. The Merlin and Ellendales mines in the same area are also known to produce excellent specimens.",
    braziliantext:
      "Brazil's Diamonds come from the gravel and sand at the bottom of rivers and streams, mainly around Minas Gerais. Diamonds from this area are known for their creamy yellow hues.",
    chakra: 'Crown',
    zodiac: 'Virgo, Libra',
    bestfor: 'Purity, Fidelity, Creativity',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    clear: 'clear',
    brazilian: 'brazilian',
    indian: 'indian',
    australian: 'australian',
  },
  {
    title: 'Dumortierite',
    description:
      'Dumortierite is a great crystal for bringing you the intuition and insight you need in order to move forward in your spiritual journey. In addition, it serves as a great communication tool that allows you to better understand and receive information from the people around you. It also enables you to communicate your inner truth with greater ease and peace. Dumortierite is known for improving memory retention and knowledge acquisition, overall improving your intellectual abilities and training you to make decisions with logic.',
    chakra: 'Throat, third eye',
    zodiac: 'Leo',
    bestfor: 'Insight, Communication, Memory',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/dumortierite',
    blue: 'blue',
  },
  {
    title: 'Fire Agate',
    description:
      'Fire Agate is known to guard you against negative energy in your environment and from toxic energy that has been accumulating in your body. In addition, it deflects any ill wishes that have been placed on you and allows you to feel more energized in your pursuit of your dreams and goals. Fire Agate is also a great proponent of creativity and inspiration, encouraging you to tap into your greatest strength to produce something of quality, especially in the arts field. With Fire Agate, you will also be able to break out of negative and harmful thought patterns and cycles.',
    text: 'Naturally opaque and often displaying colorful play-of-light effects, Fire Agate is a truly remarkable gemstone. Sri Lanka has yet to produce enough of this gem to make it commercially viable—but head to the Sabaragamuwa Province if you want to take a chance!',
    chakra: 'Root',
    zodiac: 'Gemini, Capricorn',
    bestfor: 'Energization, Creativity, Release',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/fire-agate',
    brown: 'brown',
    srilanka: 'srilanka',
  },
  {
    title: 'Goshenite',
    description:
      'Goshenite is one of the best crystals to promote self-control and discipline that can drive you towards your goals. It allows you to stick to the things that you have already made a commitment to, and in doing so, honor your obligations and devotions. In addition, Goshenite can help to facilitate communication especially between parties where a misunderstanding or miscommunication has happened. It is also a great crystal to aid in your spiritual development, connecting you with your spirit guides and guardian angels.',
    chakra: 'Crown',
    zodiac: 'Libra, Cancer',
    bestfor: 'Self-Control, Commitment, Spirituality',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    clear: 'clear',
  },
  {
    title: 'Green Apatite',
    description:
      'Green Apatite teaches you that you are worthy of achieving all your dreams and desires and guides you on the path to accomplishing them with ease. It clears away any doubt, fear and confusion that you may have on your path to spiritual and personal development. In addition, it brings you the knowledge and truth you require in order to manifest your dreams with quicker speed and greater confidence. Green Apatite connects you to nature spirits and reconnects you to the Earth’s healing and nurturing energies when you need it most.',
    chakra: 'Heart',
    zodiac: 'Taurus, Virgo',
    bestfor: 'Guidance, Personal Growth, Nature',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/green-apatite-crystal',
    green: 'green',
  },
  {
    title: 'Green Jade',
    description:
      'Green Jade is a stone of abundance and prosperity. It allows you to tap into your internal need for harmony and peace, especially in the workplace and in your home. Thus, it brings you the guidance you need to dispel any negativity that you find in the atmosphere around you. In addition, it promotes a flow of joyful energy that can return you back to your inner peace. In doing so, it will allow you to start attracting your greatest desires to you, as you are no longer chasing them, but more so attracting them into your physical reality.',
    chakra: 'Heart',
    zodiac: 'Aries',
    bestfor: 'Abundance, Harmony, Manifestion',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    green: 'green',
  },
  {
    title: 'Green Sapphire',
    description:
      'Green Sapphire dispels any negative thoughts that may be clouding your vision and heart, especially emotions such as anxiety and stress. It replaces these emotions and thoughts with optimism and peace. Known as the stone of fidelity, it brings loyalty into your relationships, allowing you to honor your commitment and devotion to the other person in your bonds, thus cultivating a stronger and healthier foundation. In addition, it helps you view others with love and treat others with compassion and kindness.',
    chakra: 'Heart',
    zodiac: 'Gemini, Libra',
    bestfor: 'Optimism, Fidelity, Devotion',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    green: 'green',
  },
  {
    title: 'Green Tourmaline',
    description:
      'Green Tourmaline encourages you to slow down in life and truly embrace all the colors and beauty of the world. In addition, it supports you in dealing with your emotional problems. It not only allows you to rid your body of all the things that no longer serve you, but it also supports your emotional body in serving as the main axis of your stability. It is one of the best suited crystals to bring luck and wealth into your life. It is also a unique miracle stone that promotes divine love and a strong connection to your higher self.',
    chakra: 'Heart',
    zodiac: 'Capricorn',
    bestfor: 'Beauty, Stability, Luck',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/green-tourmaline',
    green: 'green',
  },
  {
    title: 'Grossular Garnet',
    description:
      'Grossular Garnet is known to be a master healer, due to its ability to remind you that you are wholly abundant and blessed by the Universe. With this knowledge and true awareness, you will be able to bring spiritual and emotional healing to yourself in all matters of the heart, mind, body and soul. In addition, it is a great crystal to activate kundalini energy throughout your chakras and can help to increase confidence and self-esteem. Grossular Garnet transmutes any stagnant blockages in your emotional body into higher vibrations.',
    text: "Grossular Garnet is a variety of Garnet that's found mainly in Sri Lanka's Uva Province. Its color can vary, ranging from yellowish-green to deep red and cinnamon. The Sabaragamuwa Province also yields some excellent specimens, so be sure to check it out if you're in the area.",
    chakra: 'Heart',
    zodiac: 'Aquarius',
    bestfor: 'Abundance, Confidence, Release',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    srilanka: 'srilanka',
  },
  {
    title: 'Heliodor',
    description:
      'Heliodor brings divine wisdom to you, in order to teach you how to make better decisions - decisions that are based on logic and intellect, rather than irrationality and impulsivity. It also gives you the confidence and self-assurance that you need in order to move towards your goals and dreams with greater ease. In addition, it teaches you how to enjoy the pleasures of the Universe and attunes you to its endless possibilities. On top of that, Heliodor can protect you from anyone who wishes to harm you with ill intentions.',
    chakra: 'Solar plexus, sacral',
    zodiac: 'Leo, Gemini',
    bestfor: 'Logic, Intellect, Pleasure',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    yellow: 'yellow',
  },
  {
    title: 'Herkimer Diamond',
    description:
      "Who among us hasn't felt like a fish out of water at some point in our lives? The Herkimer Diamond is the perfect crystal for those moments when you need a little help finding your footing. This stone centers and grounds your energies, providing you with a sense of stability and security even amid chaos. The Herkimer Diamond will help you to adjust and flow with the changes, rather than feeling like you're being pulled under by the tide. Healing both the body and the mind, the Herkimer Diamond is known for its ability to ease tension headaches and stress-related illnesses such as burnout-a boon for those who push themselves too hard at work.",
    chakra: 'Crown, Third Eye',
    zodiac: 'Aries, Sagittarius',
    bestfor: 'Security, Stability, Stress Relief, Healing, Protection, Adaptation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/herkimer-diamond',
    clear: 'clear',
  },
  {
    title: 'Hiddenite',
    description:
      "Despite its name, this stone's many benefits are clear as day. The bright, lime green-bordering on pale yellow-of Hiddenite is a potent reminder of the renewing power of nature. The stone's energies are well-suited for those who find themselves in dark places, literally or figuratively. If you're feeling burdened or trapped, Hiddenite can help you to see the light at the end of the tunnel and find your way back to the path of joy and enlightenment. Hiddenite's comforting, supportive energies are perfect for those who want to work on their Heart chakra. Pessimism, jealousy, and anger are no match for this crystal's healing power.",
    chakra: 'Heart',
    zodiac: 'Cancer, Pisces, Aquarius, Virgo, Capricorn',
    bestfor: 'Happiness, Renewal, Forgiveness, Transformation, Healing, Compassion',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    green: 'green',
  },
  {
    title: 'Iceland Spar Calcite',
    description:
      "This stone, almost always as transparent as its name suggests, has a long and varied history. Used by both Vikings (as a sort of compass) and Isaac Newton (in his studies of optics), Iceland Spar Calcite is a stone with many hidden talents. Peering into its crystal-clear depths, it's not hard to see why this stone is associated with clarity and understanding. Just like the rainbows that are refracted through it, Iceland Spar Calcite brings a spectrum of colors and energies into your life. Amplifying and clearing your chakras one by one, this crystal will help you to reach new levels of self-awareness and spiritual understanding, making it an excellent stone for manifestation work. It's also useful for those who want to release old patterns of thought and behavior.",
    chakra: 'Crown, Third Eye, Heart, Root, Sacral, Throat, Sacral',
    zodiac: 'Aquarius, Cancer',
    bestfor: 'Inner Vision, Manifestation, Healing, Clarity, Insight, Transformation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Jasper Polychronic',
    description:
      "Jasper Polychronic's dense, microcrystalline structure gives it an Agate-like appearance. This stone comes in a wide range of colors-running the gamut from bright and clean to earthy-and its unique bands of color create a one-of-a-kind look that dazzles both the eye and the mind. The lively coloration of this stone is a reminder of the sublime beauty that exists all around us, even in the most mundane places. This stone is also known for its ability to promote healing on multiple fronts, but its emotional benefits are particularly noteworthy. If you're carrying around a lot of pain-either your own or someone else's - Jasper Polychronic can help you to release it and move on. Tomorrow is never just another day when you have Jasper Polychronic by your side. This stone is a lively reminder that every moment is an opportunity for growth, change, and new experiences.",
    chakra: 'Crown, Sacral, Heart, Throat, Third Eye, Solar Plexus, Root',
    zodiac: 'Leo, Cancer, Virgo, Aries',
    bestfor: 'Healing, Change, Adventure, Passion, Creativity, Vitality, Emotional Openness, Protection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'K2 Stone',
    description:
      "Carrying the supportive energies of both of its constituent stones-Granite and Azurite-its slate gray base comes splotched with orbs of vivid, electric blue. The result is a stone that is at once calming and invigorating, grounding and uplifting. When you're feeling stuck in negative patterns of thought or behavior, seemingly with no way out, K2 Stone can clear away the cobwebs and help you to recognize your path to healing and transformation. Given its strong effect on the Third Eye and Crown chakras, K2 Stone is an excellent companion for those embarking on a journey of spiritual exploration. Meditating with this stone gives you a direct line to the Divine; it's like having a GPS for your soul.",
    chakra: 'Third Eye, Crown, Throat',
    zodiac: 'Sagittarius',
    bestfor:
      'Astral Travel, Past Life Recall, Higher Self, Prophecy, Spiritual Guidance, Psychic Development, Otherworldly Wisdom',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Laguna Agate',
    description:
      "Fine strands of reddish hues-all the way from pale pink to deep crimson-swirl within the banded crystal structure of Laguna Agate. Considered a fiery agate, this stone emits an energy that is both passionate and steady, making it perfect for those who need help igniting or sustaining their inner fire. Use Laguna Agate to jump-start your creativity, sexuality, and life force energy. Create art, start a new business, or simply enjoy your hobbies with newfound gusto. In group settings, Laguna Agate helps foster cooperation and teamwork. Whether you're trying to get a project off the ground at work or coordinating an event with friends, this stone will assist in creating a harmonious atmosphere that encourages everyone to do their best.",
    chakra: 'Root',
    zodiac: 'Gemini',
    bestfor: 'Physical Stamina, Artistic Creativity, Sexuality, Passion, Motivation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Lavender Jade',
    description:
      "From afar, this stone might look like an ordinary bar of soap-and that's not entirely off the mark, given its gentle cleansing and purifying effects. But take a closer look and you'll see that Lavender Jade is anything but ordinary. Lavender Jade is known for its ability to soothe and heal the heart, making it an excellent stone for those who have suffered trauma or loss. Moving on is never easy, but Lavender Jade can give you the strength to take that crucial first step to begin the healing process; it's no surprise that healers, counselors, and therapists often keep this stone close at hand.",
    chakra: 'Third Eye, Crown, Root, Heart',
    zodiac: 'Taurus, Libra',
    bestfor: 'Healing, Forgiveness, Emotional Balance, Spiritual Connection, Creative Inspiration',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/lavender-jade-meaning',
    purple: 'purple',
  },
  {
    title: 'Lemurian',
    description:
      "The delicate nature of Lemurian-also referred to as Lemurian Quartz or Lemurian Seed Crystal-belies its strength and power. Running your fingers along its surface, you'll feel a series of horizontal grooves, a reminder that even the most fragile-seeming among us are capable of weathering any storm. Some believe that Lemurian was intentionally left behind by Lemurians-inhabitants of a long-lost civilization that was far ahead of its time, spiritually and technologically-to awaken humanity to its spiritual potential. If that's true, then it's certainly done its job, as this stone is now sought after by those on a journey of personal and spiritual growth. Lemurian is known for its ability to help us to connect with our higher selves and the Divine Feminine. Its high vibration makes it an ideal stone for meditation and psychic development.",
    chakra: 'Heart',
    zodiac: 'Taurus',
    bestfor: 'Spiritual Connection, Psychic Development, Healing, Channeling, Higher Self Connection, Divine Feminine',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Lodolite',
    description:
      'With its swirling colors and patterns as unique as a fingerprint, Lodolite is a stone that begs to be stared at and contemplated. Beginners to the world of crystals might be tempted to see Lodolite as just a pretty trinket, but this stone has some serious metaphysical muscle. Lodolite is known as a stone of transformation. It helps dissolve energy blockages and guides us through changes, both big and small, allowing us to see ourselves without judgment or preconceived notions. Often used in concert with other stones for its magnifying and amplifying effects, Lodolite can also be used on its own. Programming Lodolite is said to be especially easy, making it a great choice for those new to crystal healing.',
    chakra: 'Crown, Third Eye, Root, Heart, Throat',
    zodiac: 'Libra, Aquarius, Gemini',
    bestfor: 'Transformation, Change, Healing, Amplification, Communication, Sharpened Focus, Psychic Development',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Mangano Calcite',
    description:
      "Ranging in color from pale pink to dark rose, Mangano Calcite is one of the most popular stones for those seeking emotional healing. The gentle energy of this stone is like a soothing balm for a broken heart, and it's often used in crystal healing practices for its ability to ease grief, trauma, and stress. Mangano Calcite is also known as a stone of forgiveness, helping to release old emotional wounds and grudges. Those working on self-love and self-acceptance will find Mangano Calcite to be a powerful ally. This stone helps to fill us with compassion for ourselves and others and to banish the self-judgment that stands in the way of true healing.",
    chakra: 'Heart',
    zodiac: 'Libra',
    bestfor: 'Healing, Forgiveness, Compassion, Letting Go, Emotional Balance, Self-Love, Stress Relief',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Onyx',
    description:
      'The darkness is often seen as something to be feared, but Onyx reminds us that it can also be a source of strength. This stone helps us to look inward, to confront the things we may be avoiding, and to come to terms with our weaknesses, without fear or judgment-what we need to grow into our best selves. Its serene energy also allows us to let go of the past, and move forward into the future with a sense of peace and purpose. For those seeking protection from negative energy, Onyx is an excellent choice. This stone helps to create a shield around its wearer, deflecting negativity and absorbing any harmful or unwanted energies, helping sharpen our focus and keep us on the right path.',
    text: '',
    chakra: 'Root, Third Eye, Solar Plexus',
    zodiac: 'Leo',
    bestfor: 'Strength, Protection, Focus, Willpower, Perseverance, Determination, Self-Control',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    australian: 'australian',
  },
  {
    title: 'Orange Sapphire',
    description:
      "Another stone of creativity and abundance, Orange Sapphire also bridges the gap between the physical and spiritual worlds. It helps to heighten our intuition and to connect us with our higher selves, while also grounding us in the here and now. This stone is perfect for those who want to bring their dreams into reality. Orange Sapphire helps to increase our motivation and drive, giving us the push we need to make our vision a reality. It also helps to dissipate any creative blocks, making it a great choice for anyone seeking to unleash their creativity-whether that's through writing, art, music, or even sexual expression.",
    chakra: 'Sacral',
    zodiac: 'Taurus',
    bestfor:
      'Creativity, Intuition, Motivation, Grounding, Sexuality, Manifestation, Dreams, Visionary Work, Passion Projects',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    orange: 'orange',
  },
  {
    title: 'Pietersite',
    description:
      "A stone of vision and intuition, Pietersite helps us to connect with the higher realms and to access hidden knowledge. It is a powerful tool for shamanic journeying and anyone seeking spiritual guidance. Pietersite is also known as the Tempest Stone-a name that refers to its dramatic colors and patterns, which resemble a stormy sky. Much like a storm, this stone can help us to weather life's challenges with grace and strength. Broken relationships can often be healed with the help of Pietersite. This stone helps us to see both sides of every story and to forgive even the deepest wounds. It also helps to open our hearts to new love and to release any fears or doubts that may be holding us back.",
    chakra: 'Heart, Solar Plexus, Sacral, Third Eye',
    zodiac: 'Capricorn, Libra, Leo, Sagittarius,',
    bestfor:
      'Decisiveness, Forgiveness, Healing, Vision, Intuition, Shamanic Journeying, Spiritual Guidance, Inner Strength, New Beginnings',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Pink Quartz',
    description:
      'Pink Quartz used to be classified as a type of Rose Quartz but is now recognized as a unique variety of Quartz. Like Rose Quartz, Pink Quartz is a stone of the heart, known for its ability to dissolve emotional barriers that keep us from experiencing true love and intimacy. This gentle stone emits lush feminine energy that envelops its wearer in feelings of self-love, self-acceptance, and self-worth, easing anxiety, stress, and tension. Those struggling with grief or heartbreak will find much comfort in Pink Quartz. Note that its color is sensitive to heat and light. Preserving its delightful pink hue requires a tad more care than other stones-more than worth it for the beauty and benefits this stone provides.',
    chakra: 'Heart',
    zodiac: 'Scorpio',
    bestfor: 'Unconditional Love, Self-Love, Healing Heartache, Comfort, Anxiety Relief, Stress Relief',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    pink: 'pink',
  },
  {
    title: 'Pink Sapphire',
    description:
      "Likely the most striking and intense of all the Sapphire colors, this stone is truly breathtaking. But don't let its appearance fool you-its dainty hue belies its tremendous strength. Like bamboo swaying with the wind instead of against it, Pink Sapphire is strong yet flexible. Bending rather than breaking in the face of adversity, this stone shows us how to face up to life's challenges with indomitable grace. Forgiveness, compassion, and unconditional love are all gifts of Pink Sapphire. It is a stone that helps us to let go of the past and move forward into the future with hope and optimism.",
    chakra: 'Heart',
    zodiac: 'Taurus',
    bestfor: 'Forgiveness, Compassion, Unconditional Love, Letting Go, Moving Forward',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    pink: 'pink',
  },
  {
    title: 'Purple Jade',
    description:
      'Many stones, however powerful, are unassuming in appearance. Purple Jade is no such stone. It is a striking mineral, with a deep and rich hue that seems to shapeshift as the light catches it. The stone’s energy is just as intense as its appearance. It is said to be able to open up the Third Eye chakra, opening up heretofore unimagined psychic abilities. A powerful protection stone, Purple Jade is said to deflect negative energy and shield the wearer from psychic attacks. Empaths and highly sensitive people who are easily overwhelmed by the energy of others can benefit greatly from its protective qualities. If you are called to work with Purple Jade, know that you are being nudged by the Universe to begin (or continue) your journey of self-discovery.',
    chakra: 'Third Eye, Crown, Root',
    zodiac: 'Libra, Taurus, Pisces, Aquarius, Virgo, Gemini',
    bestfor:
      'Psychic Protection, Psychic Abilities, Self-Discovery, Emotional Healing, Stability, Astral Travel, Lucid Dreaming',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    purple: 'purple',
  },
  {
    title: 'Pyrope Garnet',
    description:
      'The bold and beautiful Pyrope Garnet is a stone that commands attention. Its magnesium and aluminum-rich composition gives it a deep red hue, reminiscent of a glowing ember from the depths of fire. Known for igniting (or rekindling) the fires of creativity, sexuality, and ambition, Pyrope Garnet hacks through the mental fog that stands in the way of success-giving you the clarity and courage you need to reclaim your power and achieve your goals. Love, passion, and courage are the hallmarks of this stone. If you are facing a situation that requires strength and fortitude, know that Pyrope Garnet is by your side, infusing you with the power you need to see it through.',
    text: 'What sets Sri Lankan Pyrope Garnet apart from the rest is its deep, saturated blood-red "eyes" that sparkle against its less flashy background tan color—like a cookie with gems instead of chocolate chips. Head to the North Cental Province, Uva Province, or Sabaragamuwa Province to get your own!',
    chakra: 'Crown, Root, Heart, Third Eye',
    zodiac: 'Aquarius',
    bestfor: 'Success, Steadfastness, Fortitude, Grounding, Protection, Love, Courage',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/pyrope-garnet-meaning',
    srilanka: 'srilanka',
  },
  {
    title: 'Seraphinite',
    description:
      'Seraphinite is a Clinochlore gem variation that is uncommon and rare with a beautiful dark green to gray color. Seraphinite is the ideal gemstone for someone ready to start over and to look for happiness and joy. The crystal can repel negative energy while also promoting revival. It will provide brilliant opportunities for the new life you are attempting to build. Seraphinite has stood the test of time and clears all blockages in your chakras, providing a pure aura. This stunning crystal will bring you peace of mind and inspire you to move forward in life with a sense of purpose.',
    chakra: 'Crown, Third eye, Throat, Heart, Solar Plexus, Sacral, Root.',
    zodiac: 'Sagittarius',
    bestfor: 'Opportunities, New beginnings, Inner peace, Passion, Inspiration.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/seraphinite-meaning',
    green: 'green',
  },
  {
    title: 'Shiva Lingam',
    description:
      "This member of the quartz family can help those seeking fertility and confidence. It stimulates all the chakras. It comes with divine female and male energies. It impacts the sacral chakra to support fertility.  The crystal is available in various sizes ranging 10 feet in length. The stone is unrivaled when it comes to memory enhancement and staying conscious. Within a few hours of having this crystal around, the energy system of the entire body improves. It allows people to understand themselves better and express their emotions to others positively. It is known to bring about purification and balance in one's life.",
    chakra: 'All Chakras',
    zodiac: 'Scorpio',
    bestfor: 'Intuition, Balance, Strength, Awakening, Fertility.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Spessartine',
    description:
      'Spessartine is not only a magnificent burnt orange crystal, but it is also excellent for heightening your emotions. These crystals will aid in manifestation and increase your creativity. Most people are unaware that spessartine is a healing stone, hence its nickname "Stone of Harmony and Good Health." The crystal has the ability to influence the Solar Plexus chakra to help you manifest dreams. It gives your brain more power, increasing mental clarity and logic. By carrying this self-healing crystal with you, you will welcome peace and harmony into your life.',
    text: "Spessartine Garnet is a rare and captivating gemstone with shades of red, orange, yellow, and brown. If you're looking for a Spessartine Garnet from Sri Lanka that everyone back home will be envious of, then you'll want to look in the Sabaragamuwa Province.",
    chakra: 'Root, Sacral, Heart.',
    zodiac: 'Aquarius',
    bestfor: 'Creative Awakening, Confidence, Self-healing, Peace, harmony, Balance.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    orange: 'orange',
    srilanka: 'srilanka',
  },
  {
    title: 'Spodumene',
    description:
      'Spodumene is a lovely white crystal (sometimes colorless) that protects you from all negative energies and even aids people suffering from perpetual motion. This crystal will help you regain your confidence if you have been mistreated as it influences your crown and soul star chakras. It protects you from many hostile forces while giving you personal and emotional space. Spodumene will help you move away from negative memories and toward positive ones. you can get your hands on some gorgeous spodumene jewelry to promote honest, integrity, remove bad memories, or become more clean and organized.',
    chakra: 'Crown, Third eye, Throat, Heart, Solar Plexus.',
    zodiac: 'Cancer',
    bestfor: 'Protection, Confidence, Emotional Fulfillment, Positivity.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Stellar Beam Calcite',
    description:
      'A Stellar Beam Calcite is excellent for attracting higher knowledge and manifestation because it has power over the crown and third eye chakras. It will assist you in recalling your life experiences, making you a more peaceful person, and assisting you in attaining a blissful state. Keeping this Calcite will assist you in breaking toxic patterns and moving away from undesirable life paths. This pretty stone can be colorless, yellow, or pale, and it can help you meet your inner version for the better.',
    chakra: 'Etheric, Crown, Third eye, Solar Plexus',
    zodiac: 'Cancer',
    bestfor: 'Expansion, Higher Self-worth, Manifestation, Personal Will.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Tanzanite',
    description:
      "Tanzanite is a stunning blue crystal variety of Zoisite. This is the crystal for you to connect your crown, third eye, and heart chakras  if you're looking for a stone that connects your heart, mind, and soul to bring out your true self. It increases your capacity for compassion while also enhancing your intellect. This crystal exposes any lies you tell yourself, assisting you in becoming more honest and truthful to yourself. You will be able to say more constructive things and let go of arguments and disagreements. It's akin to shedding old skin to accept your true self.",
    chakra: 'Etheric, Crown, Third eye, Throat, Heart',
    zodiac: 'Gemini',
    bestfor: 'Inter-dimensional Communication, Spiritual Awakening, Awareness, Truth, Sense of Purpose.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Tibetan Quartz',
    description:
      "Tibetan Quartz is an excellent aura cleanser. Many underestimate this smoky to transparent crystal, but it provides emotional, spiritual, and physical healing like no other. It elevates people to a higher path that leads to pure spiritual connections. It will give you the courage to deal with unexpected changes and provide clarity and guidance. It is prevalent for increasing wealth and improving one's financial situation. Because it is a magnificent healer, it also aids in healing the nervous system, surgical aftereffects, and pain relief.",
    chakra: 'All Chakras',
    zodiac: 'All',
    bestfor: 'Cleansing Aura, Courage, Spiritual Connections, Peace, Healing.',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    black: 'black',
  },
  {
    title: 'Tiffany Stone',
    description:
      "This captivating piece of purple fluorite and bertrandite has the power to change your life as it works best with the third eye chakra but also influences the crown chakra. It's an excellent transformer that will lead you back to yourself. You will notice an increase in your physical abilities, as well as increased access to spiritual guidance. After coming into close contact with this crystal, you will develop a keen intuition and improve your decision-making abilities. During meditation, you will find accurate answers to your questions rather than just pleasing to you.",
    chakra: 'Crown, Third Eye',
    zodiac: 'Pisces',
    bestfor: 'Intuition, Lucid Dreaming, Higher Self, Guidance, Spiritual Connection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Tiger Iron',
    description:
      "The Tiger Iron is a pale yellow and silver crystal that constantly reminds a person that anything is possible in this world. It paves the way for hard work and dedication. Your ideas and thoughts become more grounded, and you feel more courageous to face life's ups and downs as it impacts your lower chakras. The stone will assist you in overcoming procrastination and urge action. Your willpower grows stronger, and you become more concentrated on your work. When you come into close contact with the Tiger Iron crystal, your creative side takes over.",
    chakra: 'Solar Plexus, Sacral, Root',
    zodiac: 'Leo',
    bestfor: 'Courage, Growth, Creativity, Strength, Truth',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Topaz',
    description:
      'This powerful stone is renowned for its ability to heal, soothe, and stimulate both body and mind. Topaz helps cleanse and balance your energy levels to reveal the truth of your being. Feel your body fill with positive vibrations as this stone helps to reduce stress and tension, making it that much easier for joy, good fortune, and abundance to enter your life. Though all Topaz stones share these basic properties, each type of topaz has unique colorations and energies. Blue Topaz, for instance, is perfect for tapping into your inner confidence and wisdom, while yellow topaz brings happiness, creativity, and good fortune.',
    mexicantext:
      'Mexican Topaz will take your breath away with its unparalleled clarity and many hues. Luckily for Topaz fans, this gemstone is found in abundance throughout Mexico, from San Luis Potosi to Sonora.',
    australiantext:
      'Australian Topaz is chiefly sourced from alluvial gravels from rivers or sandy beaches during low tides. Faintly colored in their natural state, these gems need to be heat-treated to bring out their best colors.',
    srilankatext:
      "Sri Lankan Topaz can range from light yellow to dark blue and even brownish-green or pink. The island's Topaz hotspots are in the Sabaragamuwa and Central Uva Provinces—so if you're on the hunt for a gemstone you won't find anywhere else, then you'll want to start your search here!",
    chakra: 'Solar Plexus, Throat, Crown, Etheric, Root, Sacral',
    zodiac: 'Sagittarius, Scorpio, Leo',
    bestfor: 'Healing, Positivity, Emotional Balance, Self-Awareness',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    mexican: 'mexican',
    australian: 'australian',
    srilanka: 'srilanka',
  },
  {
    title: 'Tourmalinated Quartz',
    description:
      'The peculiar beauty of Tourmalinated Quartz lies in its swirling inclusion of Black Tourmaline strands within the icy clarity of Quartz Crystal. This unique combination not only amplifies the properties of both stones, but also creates a stone of protection and strength-making it a powerful ally in your quest for physical, mental, and emotional harmony. Black Tourmaline is known as a stone of protection, warding off negative energy and promoting positive vibes. It helps to ground you in times of stress and provides an invigorating boost when you need it most. Quartz Crystal, on the other hand, is beloved for its ability to cleanse and amplify the energies of any space or situation.',
    chakra: 'Root, Solar Plexus, Third-Eye, Heart, Crown, Sacral, Throat',
    zodiac: 'Libra, Scorpio, Capricorn',
    bestfor: 'Protection, Grounding, Healing, Clarity, Positive Energy',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/tourmalinated-quartz-meaning',
    black: 'black',
    grey: 'grey',
  },
  {
    title: 'Turritella Agate',
    description:
      'Protecting and strengthening, Turritella Agate is a stone of comfort and stability in times of flux. Travelers, students, and those amid great transitions can benefit from its energies of centering and courage. Rooted in the past, this stone offers lessons of enduring strength and fortitude. It helps us to overcome our fears and anxieties while providing insight into previous lifetimes, honing our intuitive skills, and connecting us to the wisdom of our ancestors. Survivors of trauma and abuse will find particular solace in Turritella Agate, as it surrounds and supports the fragile parts of the self with its gentle yet unyielding energies.',
    chakra: 'Root',
    zodiac: 'Gemini',
    bestfor: 'Transformation, Healing, Protection, Grounding, Past-Life Recall',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Umbalite',
    description:
      "One of the rarer, costlier members of the Garnet family, this stone's delicate coloration belies its inner strength. A blend of Pyrope and Almandine, with traces of Spessartine., Umbalite's arresting beauty comes in shades reminiscent of a rose's petals, from pale pinkish-rose to a muted red-violet. Under Umbalite's calming influence, we can see the love and compassion that underlie all of our actions, both positive and negative. It helps us to forgive ourselves for our mistakes and to move forward with confidence in our gifts and abilities. Able to unlock the door to our innermost emotions, this stone can be an invaluable ally in the treatment of heart and lung disorders, as well as enhancing our sexuality and overall metabolism.",
    chakra: 'Heart, Root, Crown',
    zodiac: 'Aquarius',
    bestfor: 'Healing, Compassion, Forgiveness, Self-Worth, Emotional Balance',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Uvarovite Garnet',
    description:
      "Ever feel like you're being called to something greater, but you're not quite sure what that is? There's a reason Uravorite Garnet is called the \"Stone of Abundance.\" This stone helps you tap into the riches of both the inner and outer worlds, its energies infusing your life with purpose, passion, and prosperity-ever so gently aligning you with your highest path. Burdensome thoughts and feelings of inadequacy melt away under Uvarovite Garnet's influence, making way for a renewed sense of hope and possibility. If you're feeling lost, or like you're just going through the motions, allow this stone to show you the way to a life without fear or limitation.",
    chakra: 'Heart, Root',
    zodiac: 'Aquarius, Taurus',
    bestfor: 'Abundance, Purpose, Passion, Prosperity, Hope, Transformation',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'Violet Sapphire',
    description:
      "Often referred to as a 'stone of awakening', Violet Sapphire is known for its ability to heighten spirituality and intuition by stimulating the pineal gland, allowing you to access higher levels of consciousness. It is also said to help calm emotional instability and ease the grieving process. Meditation with Violet Sapphire can help you to connect with your Spirit Guides, and receive guidance and clarity on your life's purpose. Its effects can also be felt on a physical level, as it is known to ease stress and eye strain, and assist in the treatment of insomnia, depression, and anxiety.",
    chakra: 'Third-Eye, Crown',
    zodiac: 'Taurus, Virgo',
    bestfor: 'Awakening, Intuition, Spirituality, Clarity, Emotional Balance, Healing',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
  },
  {
    title: 'White Sapphire',
    description:
      'This stone is the second hardest on the planet, next to diamond, and has been prized throughout history for its beauty and durability. Its hardness belies its ethereal quality, as it is known to imbue the wearer with a sense of peace and serenity. Truthseekers and philosophers will find a kindred spirit in White Sapphire, as it brings wisdom-and gives you the strength of spirit to act on it. Communicating with the Higher Self and seeking spiritual guidance is made easier with White Sapphire, as it opens and activates the Crown Chakra. It breaks down your unconscious defenses and allows you to see the true beauty of this mortal world-and your place in it-with fresh, childlike eyes.',
    chakra: 'Crown, Third-Eye',
    zodiac: 'Taurus',
    bestfor: 'Wisdom, Strength, Spirituality, Insight, Guidance, Protection',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    white: 'white',
  },
  {
    title: 'Yellow Apatite',
    description:
      "This sunny stone instills a sense of self-worth and personal power, helping you to overcome any feelings of inferiority or worthlessness. Yellow Apatite is excellent for stimulating the intellect and enhancing communication, as it facilitates the retention and understanding of new information. Both men and women benefit from Yellow Apatite's energies of strength and courage, building confidence and assertiveness. It aids in weight loss on two fronts: by amping up your metabolism as well as your resolve to stick to your diet. If you find yourself procrastinating or lacking in motivation, this is the perfect stone to help you get back on track.",
    chakra: 'Solar Plexus, Sacral',
    zodiac: 'Yellow Apatite is not associated with any particular zodiac sign',
    bestfor: 'Motivation, Confidence, Manifestation, Communication, Willpower',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/yellow-apatite-meaning',
  },
  {
    title: 'Yellow Sapphire',
    description:
      "Called the \"stone of knowledge\" by some, Yellow Sapphire is naturally excellent for mental clarity and focus, dispelling any unwanted thoughts or emotions that may be clouding your mind. Its energies of intuition and understanding will help to broaden your perspective, exhorting you to open your eyes to the beauty of your life-whether that's in your current circumstances or in the potential that lies before you. Negative emotions such as fear, anger, and jealousy dissipate in the face of Yellow Sapphire's optimistic vibrations. Due to its centering influence, it is an ideal stone to keep with you during times of stress or upheaval, as well as when you're absorbing new information or working on challenging projects.",
    chakra: 'Solar-Plexus',
    zodiac: 'Pisces, Taurus',
    bestfor: 'Knowledge, Intuition, Clarity, Emotional Balance, Optimism, Stress Relief',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: 'https://consciousitems.com/blogs/crystal-guides/yellow-sapphire-meaning',
  },
  {
    title: 'Zircon',
    description:
      "Known to be the oldest mineral on Earth, Zircon is especially prized as it is associated with all seven chakras. Zircon's energies of spiritual guidance and protection will help to cleanse and purify your soul, removing any negativity that may be holding you back. This stone is also famed for its ability to combat any evil forces or spirits by redirecting your surplus energies back to the earth they call home, bringing you closer to the Universe, and giving you a front-row seat to your own spiritual power. Zircon is an excellent stone for those seeking to connect with their higher selves or achieve spiritual enlightenment. By opening up your chakras, Zircon allows you to access previously hidden knowledge and understanding.",
    srilankatext:
      "It's the colorless Zircon from Sri Lanka that really takes our breath away. Found in alluvial deposits all over the country, these gems have exceptional fire and brilliance under even low0-light settings. Found throughout Sri Lanka, we personally favor specimens from the Eastern, Southern, and Uva Provinces.",
    australiantext:
      'Alluvial deposits of Zircon can be found in various areas on the continent, with the largest deposits located in New South Wales and Queensland. Australian Zircon is famous for its natural red, brown, and orange hues.',
    chakra: 'Root, Sacral, Solar-Plexus, Heart, Throat, Third-Eye, Crown',
    zodiac: 'Leo, Aries, Sagittarius',
    bestfor: 'Spiritual Guidance, Protection, Connection with Higher Self, Enlightenment',
    jevelry: '',
    bracelets: '',
    rings: '',
    link: '',
    srilanka: 'srilanka',
    australian: 'australian',
  },
];

/*
  {
    title: '',
    description: '',
    chakra: '',
    zodiac: '',
    bestfor: '',
    link: '',
  },
*/
